import { g as wa } from "./environment-CzIowm8J.mjs";
import * as y from "react";
import c, { useRef as Be, useMemo as $e, useState as ye, useCallback as ue, createContext as Yn, useContext as Jn, useEffect as et, useLayoutEffect as xa, useDebugValue as Sa } from "react";
import { Transition as ka, SwitchTransition as mt } from "react-transition-group";
import { useLatest as Ca } from "react-use";
import { u as oe, a as Ea, b as Aa, R as Ta } from "./contexts-CyHkJRj3.mjs";
import { c as Oa, u as Fa, b as oi, a as Ra } from "./tracking-impression-event-DxZIeaHg.mjs";
import { fetchQuery as si, commitMutation as Ia } from "react-relay";
import { a as za, r as La, u as Nt } from "./fallback-storage-value-DpM7zNd8.mjs";
import { n as nt, u as vn, e as Ba, g as Na, f as $a } from "./index-ByKJWKwE.mjs";
import { withEmotionCache as _a, ThemeContext as li, css as re, useTheme as _t } from "@emotion/react";
import { getRegisteredStyles as Ma, registerStyles as Da, insertStyles as Pa } from "@emotion/utils";
import { t as B } from "./breakpoints-DvaoDEis.mjs";
import { f as D, g as Or, b as me, a as gt } from "./variables-BSQ2K9t-.mjs";
import { useGoogleReCaptcha as Ua } from "react-google-recaptcha-v3";
import Fr from "qs";
import { isValidElementType as ci } from "react-is";
import { ThemeProvider as ja } from "@mui/material";
import ui from "deepmerge";
const { valueOf: Va, toString: qa } = Object.prototype, Ha = (e, t) => {
  const n = /* @__PURE__ */ new WeakMap(), r = (i, a) => {
    if (i === a)
      return !0;
    if (typeof i != "object" || typeof a != "object" || !i || !a)
      return i !== i && a !== a;
    if (Object.getPrototypeOf(i) !== Object.getPrototypeOf(a))
      return !1;
    const { constructor: s } = i;
    if (s === Date)
      return i.getTime() === a.getTime();
    if (s === RegExp)
      return i.source === a.source && i.flags === a.flags;
    if (s === Set) {
      if (i.size !== a.size)
        return !1;
      for (const f of i)
        if (!a.has(f))
          return !1;
      return !0;
    }
    if (s === ArrayBuffer && (i = new DataView(i), a = new DataView(a)), s === DataView || ArrayBuffer.isView(i)) {
      if (s !== DataView && (i = new DataView(i.buffer), a = new DataView(a.buffer)), i.byteLength !== a.byteLength)
        return !1;
      for (let f = i.byteLength; f-- !== 0; )
        if (i.getUint8(f) !== a.getUint8(f))
          return !1;
      return !0;
    }
    if (n.has(i) && n.get(i) === a)
      return !0;
    if (n.set(i, a), s === Array) {
      if (i.length !== a.length)
        return !1;
      for (let f = i.length; f-- !== 0; )
        if (!r(i[f], a[f]))
          return !1;
      return !0;
    }
    if (s === Map) {
      if (i.size !== a.size)
        return !1;
      for (const f of i)
        if (!a.has(f[0]) || !r(f[1], a.get(f[0])))
          return !1;
      return !0;
    }
    if (i.valueOf !== Va && typeof i.valueOf == "function" && typeof a.valueOf == "function")
      return i.valueOf() === a.valueOf();
    if (i.toString !== qa && typeof i.toString == "function" && typeof a.toString == "function")
      return i.toString() === a.toString();
    const l = Object.keys(i);
    let u;
    for (let f = l.length; f-- !== 0; )
      if (u = l[f], !Object.hasOwn(a, u) || !r(i[u], a[u]))
        return !1;
    return Object.keys(a).length === l.length;
  };
  return r(e, t);
}, Wa = (e, t, n) => {
  const r = Be(void 0);
  return (r.current === void 0 || !n(r.current, t)) && (r.current = t), $e(e, r.current);
};
function Ka(e, t) {
  return Wa(e, t, Ha);
}
function di(e = !1, t = !0) {
  const [n, r] = ye(e), i = za(t);
  return [
    n,
    ue((a) => {
      r((s) => a === void 0 || i.current && typeof a == "object" && (a.constructor.name === "SyntheticBaseEvent" || // @ts-expect-error React internals
      typeof a._reactName == "string") ? !s : !!La(a, s));
    }, [])
  ];
}
function wn() {
  return wn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wn.apply(null, arguments);
}
function Ga(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Qa = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function mi(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Za = /[A-Z]|^ms/g, Ya = /_EMO_([^_]+?)_([^]*?)_EMO_/g, fi = function(t) {
  return t.charCodeAt(1) === 45;
}, Rr = function(t) {
  return t != null && typeof t != "boolean";
}, rn = /* @__PURE__ */ mi(function(e) {
  return fi(e) ? e : e.replace(Za, "-$&").toLowerCase();
}), Ir = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Ya, function(r, i, a) {
          return Se = {
            name: i,
            styles: a,
            next: Se
          }, i;
        });
  }
  return Qa[t] !== 1 && !fi(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function ht(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return Se = {
          name: i.name,
          styles: i.styles,
          next: Se
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var s = a.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Se = {
              name: s.name,
              styles: s.styles,
              next: Se
            }, s = s.next;
        var l = a.styles + ";";
        return l;
      }
      return Ja(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var u = Se, f = n(e);
        return Se = u, ht(e, t, f);
      }
      break;
    }
  }
  var g = n;
  if (t == null)
    return g;
  var d = t[g];
  return d !== void 0 ? d : g;
}
function Ja(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += ht(e, t, n[i]) + ";";
  else
    for (var a in n) {
      var s = n[a];
      if (typeof s != "object") {
        var l = s;
        t != null && t[l] !== void 0 ? r += a + "{" + t[l] + "}" : Rr(l) && (r += rn(a) + ":" + Ir(a, l) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var u = 0; u < s.length; u++)
          Rr(s[u]) && (r += rn(a) + ":" + Ir(a, s[u]) + ";");
      else {
        var f = ht(e, t, s);
        switch (a) {
          case "animation":
          case "animationName": {
            r += rn(a) + ":" + f + ";";
            break;
          }
          default:
            r += a + "{" + f + "}";
        }
      }
    }
  return r;
}
var zr = /label:\s*([^\s;{]+)\s*(;|$)/g, Se;
function Xa(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  Se = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, i += ht(n, t, a);
  else {
    var s = a;
    i += s[0];
  }
  for (var l = 1; l < e.length; l++)
    if (i += ht(n, t, e[l]), r) {
      var u = a;
      i += u[l];
    }
  zr.lastIndex = 0;
  for (var f = "", g; (g = zr.exec(i)) !== null; )
    f += "-" + g[1];
  var d = Ga(i) + f;
  return {
    name: d,
    styles: i,
    next: Se
  };
}
var eo = function(t) {
  return t();
}, to = y.useInsertionEffect ? y.useInsertionEffect : !1, no = to || eo, ro = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, io = /* @__PURE__ */ mi(
  function(e) {
    return ro.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), ao = io, oo = function(t) {
  return t !== "theme";
}, Lr = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? ao : oo;
}, Br = function(t, n, r) {
  var i;
  if (n) {
    var a = n.shouldForwardProp;
    i = t.__emotion_forwardProp && a ? function(s) {
      return t.__emotion_forwardProp(s) && a(s);
    } : a;
  }
  return typeof i != "function" && r && (i = t.__emotion_forwardProp), i;
}, so = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return Da(n, r, i), no(function() {
    return Pa(n, r, i);
  }), null;
}, h = function e(t, n) {
  var r = t.__emotion_real === t, i = r && t.__emotion_base || t, a, s;
  n !== void 0 && (a = n.label, s = n.target);
  var l = Br(t, n, r), u = l || Lr(i), f = !u("as");
  return function() {
    var g = arguments, d = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && d.push("label:" + a + ";"), g[0] == null || g[0].raw === void 0)
      d.push.apply(d, g);
    else {
      var m = g[0];
      d.push(m[0]);
      for (var v = g.length, S = 1; S < v; S++)
        d.push(g[S], m[S]);
    }
    var b = _a(function(k, w, T) {
      var E = f && k.as || i, x = "", A = [], O = k;
      if (k.theme == null) {
        O = {};
        for (var R in k)
          O[R] = k[R];
        O.theme = y.useContext(li);
      }
      typeof k.className == "string" ? x = Ma(w.registered, A, k.className) : k.className != null && (x = k.className + " ");
      var F = Xa(d.concat(A), w.registered, O);
      x += w.key + "-" + F.name, s !== void 0 && (x += " " + s);
      var N = f && l === void 0 ? Lr(E) : u, o = {};
      for (var C in k)
        f && C === "as" || N(C) && (o[C] = k[C]);
      return o.className = x, T && (o.ref = T), /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(so, {
        cache: w,
        serialized: F,
        isStringTag: typeof E == "string"
      }), /* @__PURE__ */ y.createElement(E, o));
    });
    return b.displayName = a !== void 0 ? a : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", b.defaultProps = t.defaultProps, b.__emotion_real = b, b.__emotion_base = i, b.__emotion_styles = d, b.__emotion_forwardProp = l, Object.defineProperty(b, "toString", {
      value: function() {
        return "." + s;
      }
    }), b.withComponent = function(k, w) {
      var T = e(k, wn({}, n, w, {
        shouldForwardProp: Br(b, w, !0)
      }));
      return T.apply(void 0, d);
    }, b;
  };
};
let Dd = /* @__PURE__ */ function(e) {
  return e.Follow = "Follow", e.UnFollow = "UnFollow", e;
}({}), Pd = /* @__PURE__ */ function(e) {
  return e.BlueIcon = "blue-icon", e.BluePlusIcon = "blue-plus-icon", e.BlueSquareIcon = "blue-square-icon", e.CircleGrayIcon = "circle-gray-icon", e.Text = "text", e;
}({}), ne = /* @__PURE__ */ function(e) {
  return e.Filled = "filled", e.Outlined = "outlined", e.Plain = "plain", e;
}({}), st = /* @__PURE__ */ function(e) {
  return e.Compact = "compact", e.Full = "full", e.Large = "large", e.Normal = "normal", e.Small = "small", e.Thin = "thin", e;
}({}), Le = /* @__PURE__ */ function(e) {
  return e.Dark = "dark", e.Homepage = "homepage", e.Light = "light", e.Style = "magazines-style", e;
}({}), Ud = /* @__PURE__ */ function(e) {
  return e.Author = "Author", e.Section = "Section", e.Topic = "Topic", e;
}({});
const lo = (e) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("rect", { x: 0.5, y: 1.19922, width: 17, height: 17, rx: 1.5 }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.625 14.6992H8.375V10.3242H4V9.07422H8.375V4.69922H9.625V9.07422H14V10.3242H9.625V14.6992Z", fill: "#4585FF" })), co = (e) => /* @__PURE__ */ y.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.625 10H4.375V5.625H0V4.375H4.375V0H5.625V4.375H10V5.625H5.625V10Z", fill: "#4585FF" })), uo = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: {
  margin: "auto",
  background: "none",
  display: "block",
  shapeRendering: "auto"
}, width: "44px", height: "44px", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid", ...e }, /* @__PURE__ */ y.createElement("g", { transform: "rotate(0 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.8888888888888888s", repeatCount: "indefinite" }))), /* @__PURE__ */ y.createElement("g", { transform: "rotate(40 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.7777777777777778s", repeatCount: "indefinite" }))), /* @__PURE__ */ y.createElement("g", { transform: "rotate(80 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.6666666666666666s", repeatCount: "indefinite" }))), /* @__PURE__ */ y.createElement("g", { transform: "rotate(120 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.5555555555555556s", repeatCount: "indefinite" }))), /* @__PURE__ */ y.createElement("g", { transform: "rotate(160 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.4444444444444444s", repeatCount: "indefinite" }))), /* @__PURE__ */ y.createElement("g", { transform: "rotate(200 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.3333333333333333s", repeatCount: "indefinite" }))), /* @__PURE__ */ y.createElement("g", { transform: "rotate(240 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.2222222222222222s", repeatCount: "indefinite" }))), /* @__PURE__ */ y.createElement("g", { transform: "rotate(280 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.1111111111111111s", repeatCount: "indefinite" }))), /* @__PURE__ */ y.createElement("g", { transform: "rotate(320 50 50)" }, /* @__PURE__ */ y.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ y.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "0s", repeatCount: "indefinite" })))), mo = (e) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("rect", { x: 0.5, y: 1.19922, width: 17, height: 17, rx: 1.5, stroke: "#4585FF", fill: "#FFFFFF" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.625 14.6992H8.375V10.3242H4V9.07422H8.375V4.69922H9.625V9.07422H14V10.3242H9.625V14.6992Z", fill: "#4585FF" })), fo = (e) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("rect", { y: 0.5, width: 18, height: 18, rx: 9, fill: "#CCCCCC" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9821 6.6586L13.4232 6.125L7.37772 11.8949L4.4964 9.145L3.9375 9.67861L7.3709 12.9554L7.65406 12.698L13.9821 6.6586Z", fill: "black" })), po = (e) => /* @__PURE__ */ y.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.98246 9.01754H13.3597V9.98247H9.98246V13.359H9.01753V9.98247H5.64096V9.01754H9.01753V5.64029H9.98246V9.01754ZM18.0351 9.5C18.0351 7.1501 17.2004 5.1395 15.5305 3.46953C13.8605 1.79957 11.8499 0.964927 9.5 0.964927C7.14943 0.964927 5.1395 1.79957 3.46953 3.46953C1.79957 5.1395 0.964927 7.1501 0.964927 9.5C0.964927 11.8506 1.79957 13.8605 3.46953 15.5305C5.1395 17.2004 7.14943 18.0351 9.5 18.0351C11.8499 18.0351 13.8605 17.2004 15.5305 15.5305C17.2004 13.8605 18.0351 11.8506 18.0351 9.5ZM19 9.5C19 12.1227 18.0724 14.3613 16.2172 16.2165C14.3613 18.0724 12.122 19 9.5 19C6.87732 19 4.63871 18.0724 2.7835 16.2165C0.927607 14.3613 0 12.1227 0 9.5C0 6.878 0.927607 4.63871 2.7835 2.78282C4.63871 0.927607 6.87732 0 9.5 0C12.122 0 14.3613 0.927607 16.2172 2.78282C18.0724 4.63871 19 6.878 19 9.5Z", fill: "#BBBBBB" })), go = (e) => /* @__PURE__ */ y.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("circle", { cx: 9.5, cy: 9.5, r: 9.5, fill: "#BBBBBB" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.55311 10.7979L12.5683 6.71313L13.2989 7.45658L8.55158 12.2865L5.70325 9.38862L6.43107 8.65762L8.55311 10.7979Z", fill: "#FBFBFA" })), pi = {
  name: "ibkdlg",
  styles: "user-select:none;touch-action:manipulation;-webkit-tap-highlight-color:transparent"
}, Ge = /* @__PURE__ */ h(uo, {
  target: "eklawst9"
})(""), ho = /* @__PURE__ */ h(mo, {
  target: "eklawst8"
})(""), yo = /* @__PURE__ */ h(lo, {
  target: "eklawst7"
})(""), bo = /* @__PURE__ */ h(po, {
  target: "eklawst6"
})(""), vo = /* @__PURE__ */ h(fo, {
  target: "eklawst5"
})(""), wo = /* @__PURE__ */ h(go, {
  target: "eklawst4"
})(""), jd = /* @__PURE__ */ h("div", {
  target: "eklawst3"
})(""), Vd = /* @__PURE__ */ h("span", {
  target: "eklawst2"
})({
  name: "1kfe4k0",
  styles: "margin-inline-start:2px"
}), qd = /* @__PURE__ */ h(co, {
  target: "eklawst1"
})(""), xo = ({
  isLoading: e,
  outline: t
}) => t === ne.Plain ? "transparent" : e ? "#4585ff" : "#cccccc";
var So = {
  name: "ynfxy1",
  styles: "color:#000000;border-color:transparent;background-color:transparent"
}, ko = {
  name: "1r9f287",
  styles: "color:#4585ff;border-color:#4585ff;background-color:transparent"
}, Co = {
  name: "tjemjh",
  styles: "color:#ffffff;border-color:#001246;background-color:#001246"
}, Eo = {
  name: "1kf7pap",
  styles: "color:#ffffff;border-color:transparent;background-color:transparent"
}, Ao = {
  name: "1p9zvdh",
  styles: "color:#ffffff;border-color:#ffffff;background-color:transparent"
}, To = {
  name: "tjemjh",
  styles: "color:#ffffff;border-color:#001246;background-color:#001246"
};
const Hd = /* @__PURE__ */ h("button", {
  target: "eklawst0"
})("display:inline-flex;justify-content:center;align-items:center;text-transform:uppercase;border-style:solid;border-width:", (e) => e.outline === ne.Plain ? "0" : "1px", ";border-radius:2px;", ho, ",", yo, ",", bo, ",", vo, ",", wo, "{inline-size:18px;block-size:18px;}", (e) => {
  switch (e.size) {
    case st.Compact:
      return /* @__PURE__ */ re("inline-size:fit-content;padding:0;font-size:13px;font-family:", D, ";line-height:15px;white-space:nowrap;overflow:hidden;", Ge, "{inline-size:15px;block-size:15px;margin-block:auto;}", "");
    case st.Full:
      return /* @__PURE__ */ re("inline-size:100%;padding-block:6px;font-size:12px;font-family:", D, ";line-height:14px;", Ge, "{inline-size:14px;block-size:14px;margin-block:auto;}", "");
    case st.Large:
      return /* @__PURE__ */ re("inline-size:106px;block-size:36px;padding-block:10px;font-size:14px;font-family:", D, ";line-height:16px;", Ge, "{inline-size:16px;block-size:16px;margin-block:auto;}", "");
    case st.Small:
      return /* @__PURE__ */ re("inline-size:74px;padding-block:7px;font-size:11px;font-family:", D, ";line-height:11px;", Ge, "{inline-size:11px;block-size:11px;margin-block:auto;}", "");
    case st.Thin:
      return /* @__PURE__ */ re("inline-size:70px;padding-block:3px;font-size:11px;font-family:", D, ";line-height:13px;", Ge, "{inline-size:13px;block-size:13px;margin-block:auto;}", "");
    default:
      return /* @__PURE__ */ re("inline-size:94px;padding-block:8px;font-size:12px;font-family:", D, ";line-height:14px;text-align:center;", Ge, "{inline-size:14px;block-size:14px;margin-block:auto;}", "");
  }
}, " ", (e) => {
  if (!e.isFollowing) return null;
  switch (e.variant) {
    case Le.Dark:
      return /* @__PURE__ */ re("color:#001246;border-color:", e.outline === ne.Plain ? "transparent" : "#ffffff", ";background-color:", e.outline === ne.Plain ? "transparent" : "#ffffff", ";", "");
    case Le.Homepage:
      return /* @__PURE__ */ re("color:#000000;border-color:", xo({
        isLoading: e.isLoading,
        outline: e.outline
      }), ";background-color:", e.outline === ne.Plain || e.isLoading ? "transparent" : "#cccccc", ";", "");
    case Le.Light:
      return /* @__PURE__ */ re("color:#000000;border-color:", e.outline === ne.Plain ? "transparent" : "#e5e5e5", ";background-color:", e.outline === ne.Plain ? "transparent" : "#e5e5e5", ";", "");
    case Le.Style:
      return /* @__PURE__ */ re("inline-size:92px;color:#a1a1a1;font-weight:600;font-family:", Or, ";letter-spacing:0.36px;border-color:#a1a1a1;border-radius:4px;background-color:#ffffff;", "");
  }
}, " ", (e) => {
  if (e.isFollowing) return null;
  switch (e.variant) {
    case Le.Dark:
      switch (e.outline) {
        case ne.Filled:
          return To;
        case ne.Outlined:
          return Ao;
        case ne.Plain:
          return Eo;
      }
      break;
    case Le.Homepage:
    case Le.Light:
      switch (e.outline) {
        case ne.Filled:
          return Co;
        case ne.Outlined:
          return ko;
        case ne.Plain:
          return So;
      }
      break;
    case Le.Style:
      switch (e.outline) {
        case ne.Outlined:
          return /* @__PURE__ */ re("inline-size:83px;block-size:30px;padding:0;color:#222222;font-weight:600;font-family:", Or, ";letter-spacing:0.36px;border-color:#222222;border-radius:4px;background-color:#ffffff;", "");
      }
  }
}, " &:not(:disabled){cursor:pointer;}", pi, ";");
function Oo(e) {
  var t;
  return parseInt(y.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
function Ve(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function gi(e) {
  if (typeof e != "string")
    throw new Error(Ve(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Ne(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function hi(e) {
  if (/* @__PURE__ */ y.isValidElement(e) || ci(e) || !Ne(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = hi(e[n]);
  }), t;
}
function ae(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Ne(e) && Ne(t) && Object.keys(t).forEach((i) => {
    /* @__PURE__ */ y.isValidElement(t[i]) || ci(t[i]) ? r[i] = t[i] : Ne(t[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && Ne(e[i]) ? r[i] = ae(e[i], t[i], n) : n.clone ? r[i] = Ne(t[i]) ? hi(t[i]) : t[i] : r[i] = t[i];
  }), r;
}
function ft(e, t) {
  return t ? ae(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
function Fo(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, i) => {
    var s, l;
    const a = /min-width:\s*([0-9.]+)/;
    return +(((s = r.match(a)) == null ? void 0 : s[1]) || 0) - +(((l = i.match(a)) == null ? void 0 : l[1]) || 0);
  });
  return n.length ? n.reduce((r, i) => {
    const a = t[i];
    return delete r[i], r[i] = a, r;
  }, {
    ...t
  }) : t;
}
function Ro(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function Io(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n)
    return null;
  const [, r, i] = n, a = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(i).up(a);
}
function zo(e) {
  const t = (a, s) => a.replace("@media", s ? `@container ${s}` : "@container");
  function n(a, s) {
    a.up = (...l) => t(e.breakpoints.up(...l), s), a.down = (...l) => t(e.breakpoints.down(...l), s), a.between = (...l) => t(e.breakpoints.between(...l), s), a.only = (...l) => t(e.breakpoints.only(...l), s), a.not = (...l) => {
      const u = t(e.breakpoints.not(...l), s);
      return u.includes("not all and") ? u.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : u;
    };
  }
  const r = {}, i = (a) => (n(r, a), r);
  return n(i), {
    ...e,
    containerQueries: i
  };
}
const Mt = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Nr = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Mt[e]}px)`
}, Lo = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Mt[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function Fe(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const a = r.breakpoints || Nr;
    return t.reduce((s, l, u) => (s[a.up(a.keys[u])] = n(t[u]), s), {});
  }
  if (typeof t == "object") {
    const a = r.breakpoints || Nr;
    return Object.keys(t).reduce((s, l) => {
      if (Ro(a.keys, l)) {
        const u = Io(r.containerQueries ? r : Lo, l);
        u && (s[u] = n(t[l], l));
      } else if (Object.keys(a.values || Mt).includes(l)) {
        const u = a.up(l);
        s[u] = n(t[l], l);
      } else {
        const u = l;
        s[u] = t[u];
      }
      return s;
    }, {});
  }
  return n(t);
}
function Bo(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, i) => {
    const a = e.up(i);
    return r[a] = {}, r;
  }, {})) || {};
}
function No(e, t) {
  return e.reduce((n, r) => {
    const i = n[r];
    return (!i || Object.keys(i).length === 0) && delete n[r], n;
  }, t);
}
function Dt(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((i, a) => i && i[a] ? i[a] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, i) => r && r[i] != null ? r[i] : null, e);
}
function $t(e, t, n, r = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || r : i = Dt(e, n) || r, t && (i = t(i, r, e)), i;
}
function G(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: i
  } = e, a = (s) => {
    if (s[t] == null)
      return null;
    const l = s[t], u = s.theme, f = Dt(u, r) || {};
    return Fe(s, l, (d) => {
      let m = $t(f, i, d);
      return d === m && typeof d == "string" && (m = $t(f, i, `${t}${d === "default" ? "" : gi(d)}`, d)), n === !1 ? m : {
        [n]: m
      };
    });
  };
  return a.propTypes = {}, a.filterProps = [t], a;
}
function $o(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const _o = {
  m: "margin",
  p: "padding"
}, Mo = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, $r = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Do = $o((e) => {
  if (e.length > 2)
    if ($r[e])
      e = $r[e];
    else
      return [e];
  const [t, n] = e.split(""), r = _o[t], i = Mo[n] || "";
  return Array.isArray(i) ? i.map((a) => r + a) : [r + i];
}), Xn = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], er = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...Xn, ...er];
function St(e, t, n, r) {
  const i = Dt(e, t, !0) ?? n;
  return typeof i == "number" || typeof i == "string" ? (a) => typeof a == "string" ? a : typeof i == "string" ? `calc(${a} * ${i})` : i * a : Array.isArray(i) ? (a) => {
    if (typeof a == "string")
      return a;
    const s = Math.abs(a), l = i[s];
    return a >= 0 ? l : typeof l == "number" ? -l : `-${l}`;
  } : typeof i == "function" ? i : () => {
  };
}
function tr(e) {
  return St(e, "spacing", 8);
}
function kt(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function Po(e, t) {
  return (n) => e.reduce((r, i) => (r[i] = kt(t, n), r), {});
}
function Uo(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const i = Do(n), a = Po(i, r), s = e[n];
  return Fe(e, s, a);
}
function yi(e, t) {
  const n = tr(e.theme);
  return Object.keys(e).map((r) => Uo(e, t, r, n)).reduce(ft, {});
}
function q(e) {
  return yi(e, Xn);
}
q.propTypes = {};
q.filterProps = Xn;
function H(e) {
  return yi(e, er);
}
H.propTypes = {};
H.filterProps = er;
function Pt(...e) {
  const t = e.reduce((r, i) => (i.filterProps.forEach((a) => {
    r[a] = i;
  }), r), {}), n = (r) => Object.keys(r).reduce((i, a) => t[a] ? ft(i, t[a](r)) : i, {});
  return n.propTypes = {}, n.filterProps = e.reduce((r, i) => r.concat(i.filterProps), []), n;
}
function ce(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function pe(e, t) {
  return G({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const jo = pe("border", ce), Vo = pe("borderTop", ce), qo = pe("borderRight", ce), Ho = pe("borderBottom", ce), Wo = pe("borderLeft", ce), Ko = pe("borderColor"), Go = pe("borderTopColor"), Qo = pe("borderRightColor"), Zo = pe("borderBottomColor"), Yo = pe("borderLeftColor"), Jo = pe("outline", ce), Xo = pe("outlineColor"), Ut = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = St(e.theme, "shape.borderRadius", 4), n = (r) => ({
      borderRadius: kt(t, r)
    });
    return Fe(e, e.borderRadius, n);
  }
  return null;
};
Ut.propTypes = {};
Ut.filterProps = ["borderRadius"];
Pt(jo, Vo, qo, Ho, Wo, Ko, Go, Qo, Zo, Yo, Ut, Jo, Xo);
const jt = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = St(e.theme, "spacing", 8), n = (r) => ({
      gap: kt(t, r)
    });
    return Fe(e, e.gap, n);
  }
  return null;
};
jt.propTypes = {};
jt.filterProps = ["gap"];
const Vt = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = St(e.theme, "spacing", 8), n = (r) => ({
      columnGap: kt(t, r)
    });
    return Fe(e, e.columnGap, n);
  }
  return null;
};
Vt.propTypes = {};
Vt.filterProps = ["columnGap"];
const qt = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = St(e.theme, "spacing", 8), n = (r) => ({
      rowGap: kt(t, r)
    });
    return Fe(e, e.rowGap, n);
  }
  return null;
};
qt.propTypes = {};
qt.filterProps = ["rowGap"];
const es = G({
  prop: "gridColumn"
}), ts = G({
  prop: "gridRow"
}), ns = G({
  prop: "gridAutoFlow"
}), rs = G({
  prop: "gridAutoColumns"
}), is = G({
  prop: "gridAutoRows"
}), as = G({
  prop: "gridTemplateColumns"
}), os = G({
  prop: "gridTemplateRows"
}), ss = G({
  prop: "gridTemplateAreas"
}), ls = G({
  prop: "gridArea"
});
Pt(jt, Vt, qt, es, ts, ns, rs, is, as, os, ss, ls);
function tt(e, t) {
  return t === "grey" ? t : e;
}
const cs = G({
  prop: "color",
  themeKey: "palette",
  transform: tt
}), us = G({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: tt
}), ds = G({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: tt
});
Pt(cs, us, ds);
function ie(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const ms = G({
  prop: "width",
  transform: ie
}), nr = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var i, a, s, l, u;
      const r = ((s = (a = (i = e.theme) == null ? void 0 : i.breakpoints) == null ? void 0 : a.values) == null ? void 0 : s[n]) || Mt[n];
      return r ? ((u = (l = e.theme) == null ? void 0 : l.breakpoints) == null ? void 0 : u.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: ie(n)
      };
    };
    return Fe(e, e.maxWidth, t);
  }
  return null;
};
nr.filterProps = ["maxWidth"];
const fs = G({
  prop: "minWidth",
  transform: ie
}), ps = G({
  prop: "height",
  transform: ie
}), gs = G({
  prop: "maxHeight",
  transform: ie
}), hs = G({
  prop: "minHeight",
  transform: ie
});
G({
  prop: "size",
  cssProperty: "width",
  transform: ie
});
G({
  prop: "size",
  cssProperty: "height",
  transform: ie
});
const ys = G({
  prop: "boxSizing"
});
Pt(ms, nr, fs, ps, gs, hs, ys);
const Ht = {
  // borders
  border: {
    themeKey: "borders",
    transform: ce
  },
  borderTop: {
    themeKey: "borders",
    transform: ce
  },
  borderRight: {
    themeKey: "borders",
    transform: ce
  },
  borderBottom: {
    themeKey: "borders",
    transform: ce
  },
  borderLeft: {
    themeKey: "borders",
    transform: ce
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: ce
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Ut
  },
  // palette
  color: {
    themeKey: "palette",
    transform: tt
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: tt
  },
  backgroundColor: {
    themeKey: "palette",
    transform: tt
  },
  // spacing
  p: {
    style: H
  },
  pt: {
    style: H
  },
  pr: {
    style: H
  },
  pb: {
    style: H
  },
  pl: {
    style: H
  },
  px: {
    style: H
  },
  py: {
    style: H
  },
  padding: {
    style: H
  },
  paddingTop: {
    style: H
  },
  paddingRight: {
    style: H
  },
  paddingBottom: {
    style: H
  },
  paddingLeft: {
    style: H
  },
  paddingX: {
    style: H
  },
  paddingY: {
    style: H
  },
  paddingInline: {
    style: H
  },
  paddingInlineStart: {
    style: H
  },
  paddingInlineEnd: {
    style: H
  },
  paddingBlock: {
    style: H
  },
  paddingBlockStart: {
    style: H
  },
  paddingBlockEnd: {
    style: H
  },
  m: {
    style: q
  },
  mt: {
    style: q
  },
  mr: {
    style: q
  },
  mb: {
    style: q
  },
  ml: {
    style: q
  },
  mx: {
    style: q
  },
  my: {
    style: q
  },
  margin: {
    style: q
  },
  marginTop: {
    style: q
  },
  marginRight: {
    style: q
  },
  marginBottom: {
    style: q
  },
  marginLeft: {
    style: q
  },
  marginX: {
    style: q
  },
  marginY: {
    style: q
  },
  marginInline: {
    style: q
  },
  marginInlineStart: {
    style: q
  },
  marginInlineEnd: {
    style: q
  },
  marginBlock: {
    style: q
  },
  marginBlockStart: {
    style: q
  },
  marginBlockEnd: {
    style: q
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: jt
  },
  rowGap: {
    style: qt
  },
  columnGap: {
    style: Vt
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: ie
  },
  maxWidth: {
    style: nr
  },
  minWidth: {
    transform: ie
  },
  height: {
    transform: ie
  },
  maxHeight: {
    transform: ie
  },
  minHeight: {
    transform: ie
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function bs(...e) {
  const t = e.reduce((r, i) => r.concat(Object.keys(i)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function vs(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ws() {
  function e(n, r, i, a) {
    const s = {
      [n]: r,
      theme: i
    }, l = a[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: u = n,
      themeKey: f,
      transform: g,
      style: d
    } = l;
    if (r == null)
      return null;
    if (f === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const m = Dt(i, f) || {};
    return d ? d(s) : Fe(s, r, (S) => {
      let b = $t(m, g, S);
      return S === b && typeof S == "string" && (b = $t(m, g, `${n}${S === "default" ? "" : gi(S)}`, S)), u === !1 ? b : {
        [u]: b
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: i = {}
    } = n || {};
    if (!r)
      return null;
    const a = i.unstable_sxConfig ?? Ht;
    function s(l) {
      let u = l;
      if (typeof l == "function")
        u = l(i);
      else if (typeof l != "object")
        return l;
      if (!u)
        return null;
      const f = Bo(i.breakpoints), g = Object.keys(f);
      let d = f;
      return Object.keys(u).forEach((m) => {
        const v = vs(u[m], i);
        if (v != null)
          if (typeof v == "object")
            if (a[m])
              d = ft(d, e(m, v, i, a));
            else {
              const S = Fe({
                theme: i
              }, v, (b) => ({
                [m]: b
              }));
              bs(S, v) ? d[m] = t({
                sx: v,
                theme: i
              }) : d = ft(d, S);
            }
          else
            d = ft(d, e(m, v, i, a));
      }), Fo(i, No(g, d));
    }
    return Array.isArray(r) ? r.map(s) : s(r);
  }
  return t;
}
const Wt = ws();
Wt.filterProps = ["sx"];
var an = { exports: {} }, lt = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _r;
function xs() {
  if (_r) return lt;
  _r = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, a) {
    var s = null;
    if (a !== void 0 && (s = "" + a), i.key !== void 0 && (s = "" + i.key), "key" in i) {
      a = {};
      for (var l in i)
        l !== "key" && (a[l] = i[l]);
    } else a = i;
    return i = a.ref, {
      $$typeof: e,
      type: r,
      key: s,
      ref: i !== void 0 ? i : null,
      props: a
    };
  }
  return lt.Fragment = t, lt.jsx = n, lt.jsxs = n, lt;
}
var Mr;
function Ss() {
  return Mr || (Mr = 1, an.exports = xs()), an.exports;
}
var ks = Ss();
const Cs = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function Es(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...i
  } = e, a = Cs(t), s = Object.keys(a);
  function l(m) {
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n})`;
  }
  function u(m) {
    return `@media (max-width:${(typeof t[m] == "number" ? t[m] : m) - r / 100}${n})`;
  }
  function f(m, v) {
    const S = s.indexOf(v);
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n}) and (max-width:${(S !== -1 && typeof t[s[S]] == "number" ? t[s[S]] : v) - r / 100}${n})`;
  }
  function g(m) {
    return s.indexOf(m) + 1 < s.length ? f(m, s[s.indexOf(m) + 1]) : l(m);
  }
  function d(m) {
    const v = s.indexOf(m);
    return v === 0 ? l(s[1]) : v === s.length - 1 ? u(s[v]) : f(m, s[s.indexOf(m) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: a,
    up: l,
    down: u,
    between: f,
    only: g,
    not: d,
    unit: n,
    ...i
  };
}
const As = {
  borderRadius: 4
};
function bi(e = 8, t = tr({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (r.length === 0 ? [1] : r).map((a) => {
    const s = t(a);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" ");
  return n.mui = !0, n;
}
function Ts(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let i = n.getColorSchemeSelector(e);
    return i === "&" ? t : ((i.includes("data-") || i.includes(".")) && (i = `*:where(${i.replace(/\s*&$/, "")}) &`), {
      [i]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function vi(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: i,
    shape: a = {},
    ...s
  } = e, l = Es(n), u = bi(i);
  let f = ae({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: u,
    shape: {
      ...As,
      ...a
    }
  }, s);
  return f = zo(f), f.applyStyles = Ts, f = t.reduce((g, d) => ae(g, d), f), f.unstable_sxConfig = {
    ...Ht,
    ...s == null ? void 0 : s.unstable_sxConfig
  }, f.unstable_sx = function(d) {
    return Wt({
      sx: d,
      theme: this
    });
  }, f;
}
function Os(e) {
  return Object.keys(e).length === 0;
}
function Fs(e = null) {
  const t = y.useContext(li);
  return !t || Os(t) ? e : t;
}
const Rs = vi();
function Is(e = Rs) {
  return Fs(e);
}
function zs(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function rr(e, t = 0, n = 1) {
  return zs(e, t, n);
}
function Ls(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Me(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Me(Ls(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(Ve(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(i))
      throw new Error(Ve(10, i));
  } else
    r = r.split(",");
  return r = r.map((a) => parseFloat(a)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
const Bs = (e) => {
  const t = Me(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, ut = (e, t) => {
  try {
    return Bs(e);
  } catch {
    return e;
  }
};
function Kt(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((i, a) => a < 3 ? parseInt(i, 10) : i) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function wi(e) {
  e = Me(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, a = r * Math.min(i, 1 - i), s = (f, g = (f + n / 30) % 12) => i - a * Math.max(Math.min(g - 3, 9 - g, 1), -1);
  let l = "rgb";
  const u = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (l += "a", u.push(t[3])), Kt({
    type: l,
    values: u
  });
}
function xn(e) {
  e = Me(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Me(wi(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function Ns(e, t) {
  const n = xn(e), r = xn(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function $s(e, t) {
  return e = Me(e), t = rr(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Kt(e);
}
function It(e, t, n) {
  try {
    return $s(e, t);
  } catch {
    return e;
  }
}
function ir(e, t) {
  if (e = Me(e), t = rr(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return Kt(e);
}
function _(e, t, n) {
  try {
    return ir(e, t);
  } catch {
    return e;
  }
}
function ar(e, t) {
  if (e = Me(e), t = rr(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return Kt(e);
}
function M(e, t, n) {
  try {
    return ar(e, t);
  } catch {
    return e;
  }
}
function _s(e, t = 0.15) {
  return xn(e) > 0.5 ? ir(e, t) : ar(e, t);
}
function zt(e, t, n) {
  try {
    return _s(e, t);
  } catch {
    return e;
  }
}
function Ms(...e) {
  const t = y.useRef(void 0), n = y.useCallback((r) => {
    const i = e.map((a) => {
      if (a == null)
        return null;
      if (typeof a == "function") {
        const s = a, l = s(r);
        return typeof l == "function" ? l : () => {
          s(null);
        };
      }
      return a.current = r, () => {
        a.current = null;
      };
    });
    return () => {
      i.forEach((a) => a == null ? void 0 : a());
    };
  }, e);
  return y.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
function Ds(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const i = r[0];
    return typeof i == "string" && !i.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${i}${t(...r.slice(1))})` : `, ${i}`;
  }
  return (r, ...i) => `var(--${e ? `${e}-` : ""}${r}${t(...i)})`;
}
const Dr = (e, t, n, r = []) => {
  let i = e;
  t.forEach((a, s) => {
    s === t.length - 1 ? Array.isArray(i) ? i[Number(a)] = n : i && typeof i == "object" && (i[a] = n) : i && typeof i == "object" && (i[a] || (i[a] = r.includes(a) ? [] : {}), i = i[a]);
  });
}, Ps = (e, t, n) => {
  function r(i, a = [], s = []) {
    Object.entries(i).forEach(([l, u]) => {
      (!n || n && !n([...a, l])) && u != null && (typeof u == "object" && Object.keys(u).length > 0 ? r(u, [...a, l], Array.isArray(u) ? [...s, l] : s) : t([...a, l], u, s));
    });
  }
  r(e);
}, Us = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function on(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, i = {}, a = {}, s = {};
  return Ps(
    e,
    (l, u, f) => {
      if ((typeof u == "string" || typeof u == "number") && (!r || !r(l, u))) {
        const g = `--${n ? `${n}-` : ""}${l.join("-")}`, d = Us(l, u);
        Object.assign(i, {
          [g]: d
        }), Dr(a, l, `var(${g})`, f), Dr(s, l, `var(${g}, ${d})`, f);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: i,
    vars: a,
    varsWithDefaults: s
  };
}
function js(e, t = {}) {
  const {
    getSelector: n = k,
    disableCssColorScheme: r,
    colorSchemeSelector: i
  } = t, {
    colorSchemes: a = {},
    components: s,
    defaultColorScheme: l = "light",
    ...u
  } = e, {
    vars: f,
    css: g,
    varsWithDefaults: d
  } = on(u, t);
  let m = d;
  const v = {}, {
    [l]: S,
    ...b
  } = a;
  if (Object.entries(b || {}).forEach(([E, x]) => {
    const {
      vars: A,
      css: O,
      varsWithDefaults: R
    } = on(x, t);
    m = ae(m, R), v[E] = {
      css: O,
      vars: A
    };
  }), S) {
    const {
      css: E,
      vars: x,
      varsWithDefaults: A
    } = on(S, t);
    m = ae(m, A), v[l] = {
      css: E,
      vars: x
    };
  }
  function k(E, x) {
    var O, R;
    let A = i;
    if (i === "class" && (A = ".%s"), i === "data" && (A = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (A = `[${i}="%s"]`), E) {
      if (A === "media")
        return e.defaultColorScheme === E ? ":root" : {
          [`@media (prefers-color-scheme: ${((R = (O = a[E]) == null ? void 0 : O.palette) == null ? void 0 : R.mode) || E})`]: {
            ":root": x
          }
        };
      if (A)
        return e.defaultColorScheme === E ? `:root, ${A.replace("%s", String(E))}` : A.replace("%s", String(E));
    }
    return ":root";
  }
  return {
    vars: m,
    generateThemeVars: () => {
      let E = {
        ...f
      };
      return Object.entries(v).forEach(([, {
        vars: x
      }]) => {
        E = ae(E, x);
      }), E;
    },
    generateStyleSheets: () => {
      var F, N;
      const E = [], x = e.defaultColorScheme || "light";
      function A(o, C) {
        Object.keys(C).length && E.push(typeof o == "string" ? {
          [o]: {
            ...C
          }
        } : o);
      }
      A(n(void 0, {
        ...g
      }), g);
      const {
        [x]: O,
        ...R
      } = v;
      if (O) {
        const {
          css: o
        } = O, C = (N = (F = a[x]) == null ? void 0 : F.palette) == null ? void 0 : N.mode, I = !r && C ? {
          colorScheme: C,
          ...o
        } : {
          ...o
        };
        A(n(x, {
          ...I
        }), I);
      }
      return Object.entries(R).forEach(([o, {
        css: C
      }]) => {
        var $, Q;
        const I = (Q = ($ = a[o]) == null ? void 0 : $.palette) == null ? void 0 : Q.mode, z = !r && I ? {
          colorScheme: I,
          ...C
        } : {
          ...C
        };
        A(n(o, {
          ...z
        }), z);
      }), E;
    }
  };
}
function Vs(e) {
  return function(n) {
    return e === "media" ? `@media (prefers-color-scheme: ${n})` : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const yt = {
  black: "#000",
  white: "#fff"
}, qs = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Qe = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, Ze = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, ct = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Ye = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, Je = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Xe = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function xi() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: yt.white,
      default: yt.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const Hs = xi();
function Si() {
  return {
    text: {
      primary: yt.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: yt.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Pr = Si();
function Ur(e, t, n, r) {
  const i = r.light || r, a = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = ar(e.main, i) : t === "dark" && (e.dark = ir(e.main, a)));
}
function Ws(e = "light") {
  return e === "dark" ? {
    main: Ye[200],
    light: Ye[50],
    dark: Ye[400]
  } : {
    main: Ye[700],
    light: Ye[400],
    dark: Ye[800]
  };
}
function Ks(e = "light") {
  return e === "dark" ? {
    main: Qe[200],
    light: Qe[50],
    dark: Qe[400]
  } : {
    main: Qe[500],
    light: Qe[300],
    dark: Qe[700]
  };
}
function Gs(e = "light") {
  return e === "dark" ? {
    main: Ze[500],
    light: Ze[300],
    dark: Ze[700]
  } : {
    main: Ze[700],
    light: Ze[400],
    dark: Ze[800]
  };
}
function Qs(e = "light") {
  return e === "dark" ? {
    main: Je[400],
    light: Je[300],
    dark: Je[700]
  } : {
    main: Je[700],
    light: Je[500],
    dark: Je[900]
  };
}
function Zs(e = "light") {
  return e === "dark" ? {
    main: Xe[400],
    light: Xe[300],
    dark: Xe[700]
  } : {
    main: Xe[800],
    light: Xe[500],
    dark: Xe[900]
  };
}
function Ys(e = "light") {
  return e === "dark" ? {
    main: ct[400],
    light: ct[300],
    dark: ct[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: ct[500],
    dark: ct[900]
  };
}
function or(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...i
  } = e, a = e.primary || Ws(t), s = e.secondary || Ks(t), l = e.error || Gs(t), u = e.info || Qs(t), f = e.success || Zs(t), g = e.warning || Ys(t);
  function d(b) {
    return Ns(b, Pr.text.primary) >= n ? Pr.text.primary : Hs.text.primary;
  }
  const m = ({
    color: b,
    name: k,
    mainShade: w = 500,
    lightShade: T = 300,
    darkShade: E = 700
  }) => {
    if (b = {
      ...b
    }, !b.main && b[w] && (b.main = b[w]), !b.hasOwnProperty("main"))
      throw new Error(Ve(11, k ? ` (${k})` : "", w));
    if (typeof b.main != "string")
      throw new Error(Ve(12, k ? ` (${k})` : "", JSON.stringify(b.main)));
    return Ur(b, "light", T, r), Ur(b, "dark", E, r), b.contrastText || (b.contrastText = d(b.main)), b;
  };
  let v;
  return t === "light" ? v = xi() : t === "dark" && (v = Si()), ae({
    // A collection of common colors.
    common: {
      ...yt
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: m({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: m({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: m({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: m({
      color: g,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: m({
      color: u,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: m({
      color: f,
      name: "success"
    }),
    // The grey colors.
    grey: qs,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: m,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...v
  }, i);
}
function Js(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [i, a] = r;
    typeof a == "object" && (t[i] = `${a.fontStyle ? `${a.fontStyle} ` : ""}${a.fontVariant ? `${a.fontVariant} ` : ""}${a.fontWeight ? `${a.fontWeight} ` : ""}${a.fontStretch ? `${a.fontStretch} ` : ""}${a.fontSize || ""}${a.lineHeight ? `/${a.lineHeight} ` : ""}${a.fontFamily || ""}`);
  }), t;
}
function Xs(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function el(e) {
  return Math.round(e * 1e5) / 1e5;
}
const jr = {
  textTransform: "uppercase"
}, Vr = '"Roboto", "Helvetica", "Arial", sans-serif';
function tl(e, t) {
  const {
    fontFamily: n = Vr,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: u = 16,
    // Apply the CSS properties to all the variants.
    allVariants: f,
    pxToRem: g,
    ...d
  } = typeof t == "function" ? t(e) : t, m = r / 14, v = g || ((k) => `${k / u * m}rem`), S = (k, w, T, E, x) => ({
    fontFamily: n,
    fontWeight: k,
    fontSize: v(w),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: T,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === Vr ? {
      letterSpacing: `${el(E / w)}em`
    } : {},
    ...x,
    ...f
  }), b = {
    h1: S(i, 96, 1.167, -1.5),
    h2: S(i, 60, 1.2, -0.5),
    h3: S(a, 48, 1.167, 0),
    h4: S(a, 34, 1.235, 0.25),
    h5: S(a, 24, 1.334, 0),
    h6: S(s, 20, 1.6, 0.15),
    subtitle1: S(a, 16, 1.75, 0.15),
    subtitle2: S(s, 14, 1.57, 0.1),
    body1: S(a, 16, 1.5, 0.15),
    body2: S(a, 14, 1.43, 0.15),
    button: S(s, 14, 1.75, 0.4, jr),
    caption: S(a, 12, 1.66, 0.4),
    overline: S(a, 12, 2.66, 1, jr),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return ae({
    htmlFontSize: u,
    pxToRem: v,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: s,
    fontWeightBold: l,
    ...b
  }, d, {
    clone: !1
    // No need to clone deep
  });
}
const nl = 0.2, rl = 0.14, il = 0.12;
function V(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${nl})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${rl})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${il})`].join(",");
}
const al = ["none", V(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), V(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), V(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), V(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), V(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), V(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), V(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), V(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), V(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), V(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), V(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), V(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), V(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), V(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), V(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), V(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), V(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), V(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), V(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), V(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), V(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), V(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), V(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), V(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], ol = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, sl = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function qr(e) {
  return `${Math.round(e)}ms`;
}
function ll(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function cl(e) {
  const t = {
    ...ol,
    ...e.easing
  }, n = {
    ...sl,
    ...e.duration
  };
  return {
    getAutoHeightDuration: ll,
    create: (i = ["all"], a = {}) => {
      const {
        duration: s = n.standard,
        easing: l = t.easeInOut,
        delay: u = 0,
        ...f
      } = a;
      return (Array.isArray(i) ? i : [i]).map((g) => `${g} ${typeof s == "string" ? s : qr(s)} ${l} ${typeof u == "string" ? u : qr(u)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const ul = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function dl(e) {
  return Ne(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function ki(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const i = Object.entries(r);
    for (let a = 0; a < i.length; a++) {
      const [s, l] = i[a];
      !dl(l) || s.startsWith("unstable_") ? delete r[s] : Ne(l) && (r[s] = {
        ...l
      }, n(r[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Sn(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: i,
    palette: a = {},
    transitions: s = {},
    typography: l = {},
    shape: u,
    ...f
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(Ve(20));
  const g = or(a), d = vi(e);
  let m = ae(d, {
    mixins: Xs(d.breakpoints, r),
    palette: g,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: al.slice(),
    typography: tl(g, l),
    transitions: cl(s),
    zIndex: {
      ...ul
    }
  });
  return m = ae(m, f), m = t.reduce((v, S) => ae(v, S), m), m.unstable_sxConfig = {
    ...Ht,
    ...f == null ? void 0 : f.unstable_sxConfig
  }, m.unstable_sx = function(S) {
    return Wt({
      sx: S,
      theme: this
    });
  }, m.toRuntimeSource = ki, m;
}
function ml(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const fl = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = ml(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Ci(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Ei(e) {
  return e === "dark" ? fl : [];
}
function pl(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...i
  } = e, a = or(t);
  return {
    palette: a,
    opacity: {
      ...Ci(a.mode),
      ...n
    },
    overlays: r || Ei(a.mode),
    ...i
  };
}
function gl(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const hl = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], yl = (e) => (t, n) => {
  const r = e.rootSelector || ":root", i = e.colorSchemeSelector;
  let a = i;
  if (i === "class" && (a = ".%s"), i === "data" && (a = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (a = `[${i}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return hl(e.cssVarPrefix).forEach((l) => {
        s[l] = n[l], delete n[l];
      }), a === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: s
        }
      } : a ? {
        [a.replace("%s", t)]: s,
        [`${r}, ${a.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...s
        }
      };
    }
    if (a && a !== "media")
      return `${r}, ${a.replace("%s", String(t))}`;
  } else if (t) {
    if (a === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (a)
      return a.replace("%s", String(t));
  }
  return r;
};
function bl(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function p(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function dt(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : wi(e);
}
function Te(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = ut(dt(e[t])));
}
function vl(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const xe = (e) => {
  try {
    return e();
  } catch {
  }
}, wl = (e = "mui") => Ds(e);
function sn(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const i = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = pl({
      ...t,
      palette: {
        mode: i,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: a,
    ...s
  } = Sn({
    ...n,
    palette: {
      mode: i,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: a,
    opacity: {
      ...Ci(i),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || Ei(i)
  }, s;
}
function xl(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: i = !1,
    cssVarPrefix: a = "mui",
    shouldSkipGeneratingVar: s = gl,
    colorSchemeSelector: l = n.light && n.dark ? "media" : void 0,
    rootSelector: u = ":root",
    ...f
  } = e, g = Object.keys(n)[0], d = r || (n.light && g !== "light" ? "light" : g), m = wl(a), {
    [d]: v,
    light: S,
    dark: b,
    ...k
  } = n, w = {
    ...k
  };
  let T = v;
  if ((d === "dark" && !("dark" in n) || d === "light" && !("light" in n)) && (T = !0), !T)
    throw new Error(Ve(21, d));
  const E = sn(w, T, f, d);
  S && !w.light && sn(w, S, void 0, "light"), b && !w.dark && sn(w, b, void 0, "dark");
  let x = {
    defaultColorScheme: d,
    ...E,
    cssVarPrefix: a,
    colorSchemeSelector: l,
    rootSelector: u,
    getCssVar: m,
    colorSchemes: w,
    font: {
      ...Js(E.typography),
      ...E.font
    },
    spacing: vl(f.spacing)
  };
  Object.keys(x.colorSchemes).forEach((N) => {
    const o = x.colorSchemes[N].palette, C = (I) => {
      const z = I.split("-"), $ = z[1], Q = z[2];
      return m(I, o[$][Q]);
    };
    if (o.mode === "light" && (p(o.common, "background", "#fff"), p(o.common, "onBackground", "#000")), o.mode === "dark" && (p(o.common, "background", "#000"), p(o.common, "onBackground", "#fff")), bl(o, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), o.mode === "light") {
      p(o.Alert, "errorColor", _(o.error.light, 0.6)), p(o.Alert, "infoColor", _(o.info.light, 0.6)), p(o.Alert, "successColor", _(o.success.light, 0.6)), p(o.Alert, "warningColor", _(o.warning.light, 0.6)), p(o.Alert, "errorFilledBg", C("palette-error-main")), p(o.Alert, "infoFilledBg", C("palette-info-main")), p(o.Alert, "successFilledBg", C("palette-success-main")), p(o.Alert, "warningFilledBg", C("palette-warning-main")), p(o.Alert, "errorFilledColor", xe(() => o.getContrastText(o.error.main))), p(o.Alert, "infoFilledColor", xe(() => o.getContrastText(o.info.main))), p(o.Alert, "successFilledColor", xe(() => o.getContrastText(o.success.main))), p(o.Alert, "warningFilledColor", xe(() => o.getContrastText(o.warning.main))), p(o.Alert, "errorStandardBg", M(o.error.light, 0.9)), p(o.Alert, "infoStandardBg", M(o.info.light, 0.9)), p(o.Alert, "successStandardBg", M(o.success.light, 0.9)), p(o.Alert, "warningStandardBg", M(o.warning.light, 0.9)), p(o.Alert, "errorIconColor", C("palette-error-main")), p(o.Alert, "infoIconColor", C("palette-info-main")), p(o.Alert, "successIconColor", C("palette-success-main")), p(o.Alert, "warningIconColor", C("palette-warning-main")), p(o.AppBar, "defaultBg", C("palette-grey-100")), p(o.Avatar, "defaultBg", C("palette-grey-400")), p(o.Button, "inheritContainedBg", C("palette-grey-300")), p(o.Button, "inheritContainedHoverBg", C("palette-grey-A100")), p(o.Chip, "defaultBorder", C("palette-grey-400")), p(o.Chip, "defaultAvatarColor", C("palette-grey-700")), p(o.Chip, "defaultIconColor", C("palette-grey-700")), p(o.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), p(o.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), p(o.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), p(o.LinearProgress, "primaryBg", M(o.primary.main, 0.62)), p(o.LinearProgress, "secondaryBg", M(o.secondary.main, 0.62)), p(o.LinearProgress, "errorBg", M(o.error.main, 0.62)), p(o.LinearProgress, "infoBg", M(o.info.main, 0.62)), p(o.LinearProgress, "successBg", M(o.success.main, 0.62)), p(o.LinearProgress, "warningBg", M(o.warning.main, 0.62)), p(o.Skeleton, "bg", `rgba(${C("palette-text-primaryChannel")} / 0.11)`), p(o.Slider, "primaryTrack", M(o.primary.main, 0.62)), p(o.Slider, "secondaryTrack", M(o.secondary.main, 0.62)), p(o.Slider, "errorTrack", M(o.error.main, 0.62)), p(o.Slider, "infoTrack", M(o.info.main, 0.62)), p(o.Slider, "successTrack", M(o.success.main, 0.62)), p(o.Slider, "warningTrack", M(o.warning.main, 0.62));
      const I = zt(o.background.default, 0.8);
      p(o.SnackbarContent, "bg", I), p(o.SnackbarContent, "color", xe(() => o.getContrastText(I))), p(o.SpeedDialAction, "fabHoverBg", zt(o.background.paper, 0.15)), p(o.StepConnector, "border", C("palette-grey-400")), p(o.StepContent, "border", C("palette-grey-400")), p(o.Switch, "defaultColor", C("palette-common-white")), p(o.Switch, "defaultDisabledColor", C("palette-grey-100")), p(o.Switch, "primaryDisabledColor", M(o.primary.main, 0.62)), p(o.Switch, "secondaryDisabledColor", M(o.secondary.main, 0.62)), p(o.Switch, "errorDisabledColor", M(o.error.main, 0.62)), p(o.Switch, "infoDisabledColor", M(o.info.main, 0.62)), p(o.Switch, "successDisabledColor", M(o.success.main, 0.62)), p(o.Switch, "warningDisabledColor", M(o.warning.main, 0.62)), p(o.TableCell, "border", M(It(o.divider, 1), 0.88)), p(o.Tooltip, "bg", It(o.grey[700], 0.92));
    }
    if (o.mode === "dark") {
      p(o.Alert, "errorColor", M(o.error.light, 0.6)), p(o.Alert, "infoColor", M(o.info.light, 0.6)), p(o.Alert, "successColor", M(o.success.light, 0.6)), p(o.Alert, "warningColor", M(o.warning.light, 0.6)), p(o.Alert, "errorFilledBg", C("palette-error-dark")), p(o.Alert, "infoFilledBg", C("palette-info-dark")), p(o.Alert, "successFilledBg", C("palette-success-dark")), p(o.Alert, "warningFilledBg", C("palette-warning-dark")), p(o.Alert, "errorFilledColor", xe(() => o.getContrastText(o.error.dark))), p(o.Alert, "infoFilledColor", xe(() => o.getContrastText(o.info.dark))), p(o.Alert, "successFilledColor", xe(() => o.getContrastText(o.success.dark))), p(o.Alert, "warningFilledColor", xe(() => o.getContrastText(o.warning.dark))), p(o.Alert, "errorStandardBg", _(o.error.light, 0.9)), p(o.Alert, "infoStandardBg", _(o.info.light, 0.9)), p(o.Alert, "successStandardBg", _(o.success.light, 0.9)), p(o.Alert, "warningStandardBg", _(o.warning.light, 0.9)), p(o.Alert, "errorIconColor", C("palette-error-main")), p(o.Alert, "infoIconColor", C("palette-info-main")), p(o.Alert, "successIconColor", C("palette-success-main")), p(o.Alert, "warningIconColor", C("palette-warning-main")), p(o.AppBar, "defaultBg", C("palette-grey-900")), p(o.AppBar, "darkBg", C("palette-background-paper")), p(o.AppBar, "darkColor", C("palette-text-primary")), p(o.Avatar, "defaultBg", C("palette-grey-600")), p(o.Button, "inheritContainedBg", C("palette-grey-800")), p(o.Button, "inheritContainedHoverBg", C("palette-grey-700")), p(o.Chip, "defaultBorder", C("palette-grey-700")), p(o.Chip, "defaultAvatarColor", C("palette-grey-300")), p(o.Chip, "defaultIconColor", C("palette-grey-300")), p(o.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), p(o.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), p(o.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), p(o.LinearProgress, "primaryBg", _(o.primary.main, 0.5)), p(o.LinearProgress, "secondaryBg", _(o.secondary.main, 0.5)), p(o.LinearProgress, "errorBg", _(o.error.main, 0.5)), p(o.LinearProgress, "infoBg", _(o.info.main, 0.5)), p(o.LinearProgress, "successBg", _(o.success.main, 0.5)), p(o.LinearProgress, "warningBg", _(o.warning.main, 0.5)), p(o.Skeleton, "bg", `rgba(${C("palette-text-primaryChannel")} / 0.13)`), p(o.Slider, "primaryTrack", _(o.primary.main, 0.5)), p(o.Slider, "secondaryTrack", _(o.secondary.main, 0.5)), p(o.Slider, "errorTrack", _(o.error.main, 0.5)), p(o.Slider, "infoTrack", _(o.info.main, 0.5)), p(o.Slider, "successTrack", _(o.success.main, 0.5)), p(o.Slider, "warningTrack", _(o.warning.main, 0.5));
      const I = zt(o.background.default, 0.98);
      p(o.SnackbarContent, "bg", I), p(o.SnackbarContent, "color", xe(() => o.getContrastText(I))), p(o.SpeedDialAction, "fabHoverBg", zt(o.background.paper, 0.15)), p(o.StepConnector, "border", C("palette-grey-600")), p(o.StepContent, "border", C("palette-grey-600")), p(o.Switch, "defaultColor", C("palette-grey-300")), p(o.Switch, "defaultDisabledColor", C("palette-grey-600")), p(o.Switch, "primaryDisabledColor", _(o.primary.main, 0.55)), p(o.Switch, "secondaryDisabledColor", _(o.secondary.main, 0.55)), p(o.Switch, "errorDisabledColor", _(o.error.main, 0.55)), p(o.Switch, "infoDisabledColor", _(o.info.main, 0.55)), p(o.Switch, "successDisabledColor", _(o.success.main, 0.55)), p(o.Switch, "warningDisabledColor", _(o.warning.main, 0.55)), p(o.TableCell, "border", _(It(o.divider, 1), 0.68)), p(o.Tooltip, "bg", It(o.grey[700], 0.92));
    }
    Te(o.background, "default"), Te(o.background, "paper"), Te(o.common, "background"), Te(o.common, "onBackground"), Te(o, "divider"), Object.keys(o).forEach((I) => {
      const z = o[I];
      I !== "tonalOffset" && z && typeof z == "object" && (z.main && p(o[I], "mainChannel", ut(dt(z.main))), z.light && p(o[I], "lightChannel", ut(dt(z.light))), z.dark && p(o[I], "darkChannel", ut(dt(z.dark))), z.contrastText && p(o[I], "contrastTextChannel", ut(dt(z.contrastText))), I === "text" && (Te(o[I], "primary"), Te(o[I], "secondary")), I === "action" && (z.active && Te(o[I], "active"), z.selected && Te(o[I], "selected")));
    });
  }), x = t.reduce((N, o) => ae(N, o), x);
  const A = {
    prefix: a,
    disableCssColorScheme: i,
    shouldSkipGeneratingVar: s,
    getSelector: yl(x)
  }, {
    vars: O,
    generateThemeVars: R,
    generateStyleSheets: F
  } = js(x, A);
  return x.vars = O, Object.entries(x.colorSchemes[x.defaultColorScheme]).forEach(([N, o]) => {
    x[N] = o;
  }), x.generateThemeVars = R, x.generateStyleSheets = F, x.generateSpacing = function() {
    return bi(f.spacing, tr(this));
  }, x.getColorSchemeSelector = Vs(l), x.spacing = x.generateSpacing(), x.shouldSkipGeneratingVar = s, x.unstable_sxConfig = {
    ...Ht,
    ...f == null ? void 0 : f.unstable_sxConfig
  }, x.unstable_sx = function(o) {
    return Wt({
      sx: o,
      theme: this
    });
  }, x.toRuntimeSource = ki, x;
}
function Hr(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: or({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function Sl(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: i = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: a = n == null ? void 0 : n.mode,
    ...s
  } = e, l = a || "light", u = i == null ? void 0 : i[l], f = {
    ...i,
    ...n ? {
      [l]: {
        ...typeof u != "boolean" && u,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return Sn(e, ...t);
    let g = n;
    "palette" in e || f[l] && (f[l] !== !0 ? g = f[l].palette : l === "dark" && (g = {
      mode: "dark"
    }));
    const d = Sn({
      ...e,
      palette: g
    }, ...t);
    return d.defaultColorScheme = l, d.colorSchemes = f, d.palette.mode === "light" && (d.colorSchemes.light = {
      ...f.light !== !0 && f.light,
      palette: d.palette
    }, Hr(d, "dark", f.dark)), d.palette.mode === "dark" && (d.colorSchemes.dark = {
      ...f.dark !== !0 && f.dark,
      palette: d.palette
    }, Hr(d, "light", f.light)), d;
  }
  return !n && !("light" in f) && l === "light" && (f.light = !0), xl({
    ...s,
    colorSchemes: f,
    defaultColorScheme: l,
    ...typeof r != "boolean" && r
  }, ...t);
}
const kl = Sl(), Cl = "$$material";
function El() {
  const e = Is(kl);
  return e[Cl] || e;
}
const Al = (e) => e.scrollTop;
function Wr(e, t) {
  const {
    timeout: n,
    easing: r,
    style: i = {}
  } = e;
  return {
    duration: i.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: i.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: i.transitionDelay
  };
}
const Tl = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, pt = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = El(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: s = !0,
    children: l,
    easing: u,
    in: f,
    onEnter: g,
    onEntered: d,
    onEntering: m,
    onExit: v,
    onExited: S,
    onExiting: b,
    style: k,
    timeout: w = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: T = ka,
    ...E
  } = t, x = y.useRef(null), A = Ms(x, Oo(l), n), O = ($) => (Q) => {
    if ($) {
      const se = x.current;
      Q === void 0 ? $(se) : $(se, Q);
    }
  }, R = O(m), F = O(($, Q) => {
    Al($);
    const se = Wr({
      style: k,
      timeout: w,
      easing: u
    }, {
      mode: "enter"
    });
    $.style.webkitTransition = r.transitions.create("opacity", se), $.style.transition = r.transitions.create("opacity", se), g && g($, Q);
  }), N = O(d), o = O(b), C = O(($) => {
    const Q = Wr({
      style: k,
      timeout: w,
      easing: u
    }, {
      mode: "exit"
    });
    $.style.webkitTransition = r.transitions.create("opacity", Q), $.style.transition = r.transitions.create("opacity", Q), v && v($);
  }), I = O(S), z = ($) => {
    a && a(x.current, $);
  };
  return /* @__PURE__ */ ks.jsx(T, {
    appear: s,
    in: f,
    nodeRef: x,
    onEnter: F,
    onEntered: N,
    onEntering: R,
    onExit: C,
    onExited: I,
    onExiting: o,
    addEndListener: z,
    timeout: w,
    ...E,
    children: ($, {
      ownerState: Q,
      ...se
    }) => /* @__PURE__ */ y.cloneElement(l, {
      style: {
        opacity: 0,
        visibility: $ === "exited" && !f ? "hidden" : void 0,
        ...Tl[$],
        ...k,
        ...l.props.style
      },
      ref: A,
      ...se
    })
  });
});
var ln, Kr;
function Ol() {
  if (Kr) return ln;
  Kr = 1;
  function e(t) {
    return t && t.length ? t[0] : void 0;
  }
  return ln = e, ln;
}
var cn, Gr;
function Fl() {
  return Gr || (Gr = 1, cn = Ol()), cn;
}
var Rl = Fl();
const Ai = /* @__PURE__ */ wa(Rl), sr = /* @__PURE__ */ Yn({
  inMiniHeader: !1
}), Wd = ({
  children: e
}) => /* @__PURE__ */ c.createElement(sr.Provider, {
  value: {
    inMiniHeader: !0
  },
  "data-qa": "mini-header-indicator-context-provider"
}, e);
sr.displayName = "MiniHeaderIndicatorContext";
const Il = () => Jn(sr), Kd = () => {
  const {
    currentArticleId: e,
    rosettaInstance: t
  } = oe();
  return {
    computeGA4CommonParameters: ue(() => t ? {
      ...t.rulesEngine.getOutcome("tracking.ga4.baseParameters"),
      ...e ? {
        article_id: e
      } : {}
    } : {}, [e, t])
  };
}, zl = (e) => {
  const {
    handleTrackGA4: t
  } = oe(), {
    inMiniHeader: n
  } = Il(), {
    ga4Event: r
  } = e, {
    captureTrackImpressionEventTargetElement: i,
    intersection: a
  } = Oa({
    ga4TrackingHandler: t,
    getGa4Event: r,
    options: {
      intersectionThreshold: [0.5],
      isSendGA4Tracking: !n,
      shouldSendOnce: !0
    }
  });
  return {
    captureTrackImpressionEventTargetElement: i,
    intersection: a
  };
};
let X = /* @__PURE__ */ function(e) {
  return e.FindOutMore = "find-out-more", e.SignUpNewsletter = "sign-up-newsletter", e.SignUpSuccessMessage = "sign-up-success-message", e;
}({}), U = /* @__PURE__ */ function(e) {
  return e.AcquisitionNewsletterPopup = "acquisition-newsletter-popup", e.Article = "article", e.Article20 = "article20", e.ArticleDark = "article-dark", e.Footer = "footer", e.Homepage = "homepage", e.LiveArticle = "live-article", e.NewsletterArticle = "newsletter-article", e.NewsletterArticleBottom = "newsletter-article-bottom", e.NewsletterList = "newsletter-list", e.Posties = "posties", e.Section = "section", e;
}({});
const lr = /* @__PURE__ */ Yn({
  campaignName: "",
  dataMatrix: {},
  newsletterItems: [],
  queryParametersForSocialButtons: {},
  variant: U.Footer
}), Ll = ({
  children: e,
  multipleNewsletters: t = !1,
  value: {
    newsletterItems: n,
    ...r
  }
}) => {
  const [i, a] = ye(""), s = $e(() => Ai(n), [n]);
  return /* @__PURE__ */ c.createElement(lr.Provider, {
    value: {
      ...r,
      lastSubscribedNewsletter: i,
      newsletterItemForDisplay: s,
      newsletterItems: t ? n : n.slice(0, 1),
      setLastSubscribedNewsletter: a
    },
    "data-qa": "newsletter-context-provider"
  }, e);
};
lr.displayName = "NewsletterContext";
const ve = () => Jn(lr), Ti = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "first"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "newsletterIds"
  }], t = [{
    fields: [{
      kind: "Variable",
      name: "entityIds",
      variableName: "newsletterIds"
    }],
    kind: "ObjectValue",
    name: "filter"
  }, {
    kind: "Variable",
    name: "first",
    variableName: "first"
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "name",
    storageKey: null
  }, i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "alternativeName",
    storageKey: null
  }, a = [{
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "text",
    storageKey: null
  }], s = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "description",
    plural: !1,
    selections: a,
    storageKey: null
  }, l = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "summary",
    plural: !1,
    selections: a,
    storageKey: null
  }, u = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "homepageDescription",
    plural: !1,
    selections: a,
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "hooksNewsletterQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "NewsletterConnection",
        kind: "LinkedField",
        name: "newsletters",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "NewsletterEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Newsletter",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              n,
              r,
              i,
              s,
              l,
              u
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "hooksNewsletterQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "NewsletterConnection",
        kind: "LinkedField",
        name: "newsletters",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "NewsletterEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Newsletter",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [n, r, i, s, l, u, {
              alias: null,
              args: null,
              kind: "ScalarField",
              name: "id",
              storageKey: null
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }]
    },
    params: {
      cacheID: "db6ce7df57fd46a0894ca1c99f5593c8",
      id: null,
      metadata: {},
      name: "hooksNewsletterQuery",
      operationKind: "query",
      text: `query hooksNewsletterQuery(
  $first: Int
  $newsletterIds: [String]
) {
  newsletters(first: $first, filter: {entityIds: $newsletterIds}) {
    edges {
      node {
        entityId
        name
        alternativeName
        description {
          text
        }
        summary {
          text
        }
        homepageDescription {
          text
        }
        id
      }
    }
  }
}
`
    }
  };
}();
Ti.hash = "07926024ff85778e6f495ad0f59ef656";
var un = { exports: {} }, dn = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qr;
function Bl() {
  if (Qr) return dn;
  Qr = 1;
  var e = c;
  function t(d, m) {
    return d === m && (d !== 0 || 1 / d === 1 / m) || d !== d && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, a = e.useLayoutEffect, s = e.useDebugValue;
  function l(d, m) {
    var v = m(), S = r({ inst: { value: v, getSnapshot: m } }), b = S[0].inst, k = S[1];
    return a(
      function() {
        b.value = v, b.getSnapshot = m, u(b) && k({ inst: b });
      },
      [d, v, m]
    ), i(
      function() {
        return u(b) && k({ inst: b }), d(function() {
          u(b) && k({ inst: b });
        });
      },
      [d]
    ), s(v), v;
  }
  function u(d) {
    var m = d.getSnapshot;
    d = d.value;
    try {
      var v = m();
      return !n(d, v);
    } catch {
      return !0;
    }
  }
  function f(d, m) {
    return m();
  }
  var g = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? f : l;
  return dn.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : g, dn;
}
var Zr;
function Nl() {
  return Zr || (Zr = 1, un.exports = Bl()), un.exports;
}
var $l = Nl();
const Oi = 0, Fi = 1, Ri = 2, Yr = 3;
var Jr = Object.prototype.hasOwnProperty;
function kn(e, t) {
  var n, r;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((r = e.length) === t.length)
        for (; r-- && kn(e[r], t[r]); ) ;
      return r === -1;
    }
    if (!n || typeof e == "object") {
      r = 0;
      for (n in e)
        if (Jr.call(e, n) && ++r && !Jr.call(t, n) || !(n in t) || !kn(e[n], t[n])) return !1;
      return Object.keys(t).length === r;
    }
  }
  return e !== e && t !== t;
}
const Oe = /* @__PURE__ */ new WeakMap(), _e = () => {
}, te = (
  /*#__NOINLINE__*/
  _e()
), Cn = Object, L = (e) => e === te, ke = (e) => typeof e == "function", De = (e, t) => ({
  ...e,
  ...t
}), Ii = (e) => ke(e.then), mn = {}, Lt = {}, cr = "undefined", Ct = typeof window != cr, En = typeof document != cr, _l = Ct && "Deno" in window, Ml = () => Ct && typeof window.requestAnimationFrame != cr, zi = (e, t) => {
  const n = Oe.get(e);
  return [
    // Getter
    () => !L(t) && e.get(t) || mn,
    // Setter
    (r) => {
      if (!L(t)) {
        const i = e.get(t);
        t in Lt || (Lt[t] = i), n[5](t, De(i, r), i || mn);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !L(t) && t in Lt ? Lt[t] : !L(t) && e.get(t) || mn
  ];
};
let An = !0;
const Dl = () => An, [Tn, On] = Ct && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  _e,
  _e
], Pl = () => {
  const e = En && document.visibilityState;
  return L(e) || e !== "hidden";
}, Ul = (e) => (En && document.addEventListener("visibilitychange", e), Tn("focus", e), () => {
  En && document.removeEventListener("visibilitychange", e), On("focus", e);
}), jl = (e) => {
  const t = () => {
    An = !0, e();
  }, n = () => {
    An = !1;
  };
  return Tn("online", t), Tn("offline", n), () => {
    On("online", t), On("offline", n);
  };
}, Vl = {
  isOnline: Dl,
  isVisible: Pl
}, ql = {
  initFocus: Ul,
  initReconnect: jl
}, Xr = !c.useId, bt = !Ct || _l, Hl = (e) => Ml() ? window.requestAnimationFrame(e) : setTimeout(e, 1), fn = bt ? et : xa, pn = typeof navigator < "u" && navigator.connection, ei = !bt && pn && ([
  "slow-2g",
  "2g"
].includes(pn.effectiveType) || pn.saveData), Bt = /* @__PURE__ */ new WeakMap(), gn = (e, t) => Cn.prototype.toString.call(e) === `[object ${t}]`;
let Wl = 0;
const Fn = (e) => {
  const t = typeof e, n = gn(e, "Date"), r = gn(e, "RegExp"), i = gn(e, "Object");
  let a, s;
  if (Cn(e) === e && !n && !r) {
    if (a = Bt.get(e), a) return a;
    if (a = ++Wl + "~", Bt.set(e, a), Array.isArray(e)) {
      for (a = "@", s = 0; s < e.length; s++)
        a += Fn(e[s]) + ",";
      Bt.set(e, a);
    }
    if (i) {
      a = "#";
      const l = Cn.keys(e).sort();
      for (; !L(s = l.pop()); )
        L(e[s]) || (a += s + ":" + Fn(e[s]) + ",");
      Bt.set(e, a);
    }
  } else
    a = n ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return a;
}, ur = (e) => {
  if (ke(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? Fn(e) : "", [
    e,
    t
  ];
};
let Kl = 0;
const Rn = () => ++Kl;
async function Li(...e) {
  const [t, n, r, i] = e, a = De({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let s = a.populateCache;
  const l = a.rollbackOnError;
  let u = a.optimisticData;
  const f = (m) => typeof l == "function" ? l(m) : l !== !1, g = a.throwOnError;
  if (ke(n)) {
    const m = n, v = [], S = t.keys();
    for (const b of S)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(b) && m(t.get(b)._k) && v.push(b);
    return Promise.all(v.map(d));
  }
  return d(n);
  async function d(m) {
    const [v] = ur(m);
    if (!v) return;
    const [S, b] = zi(t, v), [k, w, T, E] = Oe.get(t), x = () => {
      const z = k[v];
      return (ke(a.revalidate) ? a.revalidate(S().data, m) : a.revalidate !== !1) && (delete T[v], delete E[v], z && z[0]) ? z[0](Ri).then(() => S().data) : S().data;
    };
    if (e.length < 3)
      return x();
    let A = r, O;
    const R = Rn();
    w[v] = [
      R,
      0
    ];
    const F = !L(u), N = S(), o = N.data, C = N._c, I = L(C) ? o : C;
    if (F && (u = ke(u) ? u(I, o) : u, b({
      data: u,
      _c: I
    })), ke(A))
      try {
        A = A(I);
      } catch (z) {
        O = z;
      }
    if (A && Ii(A))
      if (A = await A.catch((z) => {
        O = z;
      }), R !== w[v][0]) {
        if (O) throw O;
        return A;
      } else O && F && f(O) && (s = !0, b({
        data: I,
        _c: te
      }));
    if (s && !O)
      if (ke(s)) {
        const z = s(A, I);
        b({
          data: z,
          error: te,
          _c: te
        });
      } else
        b({
          data: A,
          error: te,
          _c: te
        });
    if (w[v][1] = Rn(), Promise.resolve(x()).then(() => {
      b({
        _c: te
      });
    }), O) {
      if (g) throw O;
      return;
    }
    return A;
  }
}
const ti = (e, t) => {
  for (const n in e)
    e[n][0] && e[n][0](t);
}, Gl = (e, t) => {
  if (!Oe.has(e)) {
    const n = De(ql, t), r = /* @__PURE__ */ Object.create(null), i = Li.bind(te, e);
    let a = _e;
    const s = /* @__PURE__ */ Object.create(null), l = (g, d) => {
      const m = s[g] || [];
      return s[g] = m, m.push(d), () => m.splice(m.indexOf(d), 1);
    }, u = (g, d, m) => {
      e.set(g, d);
      const v = s[g];
      if (v)
        for (const S of v)
          S(d, m);
    }, f = () => {
      if (!Oe.has(e) && (Oe.set(e, [
        r,
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        i,
        u,
        l
      ]), !bt)) {
        const g = n.initFocus(setTimeout.bind(te, ti.bind(te, r, Oi))), d = n.initReconnect(setTimeout.bind(te, ti.bind(te, r, Fi)));
        a = () => {
          g && g(), d && d(), Oe.delete(e);
        };
      }
    };
    return f(), [
      e,
      i,
      f,
      a
    ];
  }
  return [
    e,
    Oe.get(e)[4]
  ];
}, Ql = (e, t, n, r, i) => {
  const a = n.errorRetryCount, s = i.retryCount, l = ~~((Math.random() + 0.5) * (1 << (s < 8 ? s : 8))) * n.errorRetryInterval;
  !L(a) && s > a || setTimeout(r, l, i);
}, Zl = kn, [Bi, Yl] = Gl(/* @__PURE__ */ new Map()), Jl = De(
  {
    // events
    onLoadingSlow: _e,
    onSuccess: _e,
    onError: _e,
    onErrorRetry: Ql,
    onDiscarded: _e,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: ei ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: ei ? 5e3 : 3e3,
    // providers
    compare: Zl,
    isPaused: () => !1,
    cache: Bi,
    mutate: Yl,
    fallback: {}
  },
  // use web preset by default
  Vl
), Xl = (e, t) => {
  const n = De(e, t);
  if (t) {
    const { use: r, fallback: i } = e, { use: a, fallback: s } = t;
    r && a && (n.use = r.concat(a)), i && s && (n.fallback = De(i, s));
  }
  return n;
}, ec = Yn({}), tc = "$inf$", Ni = Ct && window.__SWR_DEVTOOLS_USE__, nc = Ni ? window.__SWR_DEVTOOLS_USE__ : [], rc = () => {
  Ni && (window.__SWR_DEVTOOLS_REACT__ = c);
}, $i = (e) => ke(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], ic = () => De(Jl, Jn(ec)), ac = (e) => (t, n, r) => e(t, n && ((...a) => {
  const [s] = ur(t), [, , , l] = Oe.get(Bi);
  if (s.startsWith(tc))
    return n(...a);
  const u = l[s];
  return L(u) ? n(...a) : (delete l[s], u);
}), r), oc = nc.concat(ac), sc = (e) => function(...n) {
  const r = ic(), [i, a, s] = $i(n), l = Xl(r, s);
  let u = e;
  const { use: f } = l, g = (f || []).concat(oc);
  for (let d = g.length; d--; )
    u = g[d](u);
  return u(i, a || l.fetcher || null, l);
}, lc = (e, t, n) => {
  const r = t[e] || (t[e] = []);
  return r.push(n), () => {
    const i = r.indexOf(n);
    i >= 0 && (r[i] = r[r.length - 1], r.pop());
  };
}, cc = (e, t) => (...n) => {
  const [r, i, a] = $i(n), s = (a.use || []).concat(t);
  return e(r, i, {
    ...a,
    use: s
  });
};
rc();
const hn = c.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((e) => {
  switch (e.status) {
    case "pending":
      throw e;
    case "fulfilled":
      return e.value;
    case "rejected":
      throw e.reason;
    default:
      throw e.status = "pending", e.then((t) => {
        e.status = "fulfilled", e.value = t;
      }, (t) => {
        e.status = "rejected", e.reason = t;
      }), e;
  }
}), yn = {
  dedupe: !0
}, uc = (e, t, n) => {
  const { cache: r, compare: i, suspense: a, fallbackData: s, revalidateOnMount: l, revalidateIfStale: u, refreshInterval: f, refreshWhenHidden: g, refreshWhenOffline: d, keepPreviousData: m } = n, [v, S, b, k] = Oe.get(r), [w, T] = ur(e), E = Be(!1), x = Be(!1), A = Be(w), O = Be(t), R = Be(n), F = () => R.current, N = () => F().isVisible() && F().isOnline(), [o, C, I, z] = zi(r, w), $ = Be({}).current, Q = L(s) ? L(n.fallback) ? te : n.fallback[w] : s, se = (j, P) => {
    for (const J in $) {
      const K = J;
      if (K === "data") {
        if (!i(j[K], P[K]) && (!L(j[K]) || !i(Rt, P[K])))
          return !1;
      } else if (P[K] !== j[K])
        return !1;
    }
    return !0;
  }, Tt = $e(() => {
    const j = !w || !t ? !1 : L(l) ? F().isPaused() || a ? !1 : u !== !1 : l, P = (ee) => {
      const Ee = De(ee);
      return delete Ee._k, j ? {
        isValidating: !0,
        isLoading: !0,
        ...Ee
      } : Ee;
    }, J = o(), K = z(), he = P(J), Ke = J === K ? he : P(K);
    let Y = he;
    return [
      () => {
        const ee = P(o());
        return se(ee, Y) ? (Y.data = ee.data, Y.isLoading = ee.isLoading, Y.isValidating = ee.isValidating, Y.error = ee.error, Y) : (Y = ee, ee);
      },
      () => Ke
    ];
  }, [
    r,
    w
  ]), ze = $l.useSyncExternalStore(ue(
    (j) => I(w, (P, J) => {
      se(J, P) || j();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      w
    ]
  ), Tt[0], Tt[1]), Ot = !E.current, W = v[w] && v[w].length > 0, we = ze.data, Ce = L(we) ? Q && Ii(Q) ? hn(Q) : Q : we, Ft = ze.error, en = Be(Ce), Rt = m ? L(we) ? L(en.current) ? Ce : en.current : we : Ce, Sr = W && !L(Ft) ? !1 : Ot && !L(l) ? l : F().isPaused() ? !1 : a ? L(Ce) ? !1 : u : L(Ce) || u, kr = !!(w && t && Ot && Sr), ya = L(ze.isValidating) ? kr : ze.isValidating, ba = L(ze.isLoading) ? kr : ze.isLoading, ot = ue(
    async (j) => {
      const P = O.current;
      if (!w || !P || x.current || F().isPaused())
        return !1;
      let J, K, he = !0;
      const Ke = j || {}, Y = !b[w] || !Ke.dedupe, ee = () => Xr ? !x.current && w === A.current && E.current : w === A.current, Ee = {
        isValidating: !1,
        isLoading: !1
      }, Er = () => {
        C(Ee);
      }, Ar = () => {
        const le = b[w];
        le && le[1] === K && delete b[w];
      }, Tr = {
        isValidating: !0
      };
      L(o().data) && (Tr.isLoading = !0);
      try {
        if (Y && (C(Tr), n.loadingTimeout && L(o().data) && setTimeout(() => {
          he && ee() && F().onLoadingSlow(w, n);
        }, n.loadingTimeout), b[w] = [
          P(T),
          Rn()
        ]), [J, K] = b[w], J = await J, Y && setTimeout(Ar, n.dedupingInterval), !b[w] || b[w][1] !== K)
          return Y && ee() && F().onDiscarded(w), !1;
        Ee.error = te;
        const le = S[w];
        if (!L(le) && // case 1
        (K <= le[0] || // case 2
        K <= le[1] || // case 3
        le[1] === 0))
          return Er(), Y && ee() && F().onDiscarded(w), !1;
        const Ae = o().data;
        Ee.data = i(Ae, J) ? Ae : J, Y && ee() && F().onSuccess(J, w, n);
      } catch (le) {
        Ar();
        const Ae = F(), { shouldRetryOnError: tn } = Ae;
        Ae.isPaused() || (Ee.error = le, Y && ee() && (Ae.onError(le, w, Ae), (tn === !0 || ke(tn) && tn(le)) && (!F().revalidateOnFocus || !F().revalidateOnReconnect || N()) && Ae.onErrorRetry(le, w, Ae, (va) => {
          const nn = v[w];
          nn && nn[0] && nn[0](Yr, va);
        }, {
          retryCount: (Ke.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return he = !1, Er(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      w,
      r
    ]
  ), Cr = ue(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...j) => Li(r, A.current, ...j),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (fn(() => {
    O.current = t, R.current = n, L(we) || (en.current = we);
  }), fn(() => {
    if (!w) return;
    const j = ot.bind(te, yn);
    let P = 0;
    F().revalidateOnFocus && (P = Date.now() + F().focusThrottleInterval);
    const K = lc(w, v, (he, Ke = {}) => {
      if (he == Oi) {
        const Y = Date.now();
        F().revalidateOnFocus && Y > P && N() && (P = Y + F().focusThrottleInterval, j());
      } else if (he == Fi)
        F().revalidateOnReconnect && N() && j();
      else {
        if (he == Ri)
          return ot();
        if (he == Yr)
          return ot(Ke);
      }
    });
    return x.current = !1, A.current = w, E.current = !0, C({
      _k: T
    }), Sr && (L(Ce) || bt ? j() : Hl(j)), () => {
      x.current = !0, K();
    };
  }, [
    w
  ]), fn(() => {
    let j;
    function P() {
      const K = ke(f) ? f(o().data) : f;
      K && j !== -1 && (j = setTimeout(J, K));
    }
    function J() {
      !o().error && (g || F().isVisible()) && (d || F().isOnline()) ? ot(yn).then(P) : P();
    }
    return P(), () => {
      j && (clearTimeout(j), j = -1);
    };
  }, [
    f,
    g,
    d,
    w
  ]), Sa(Rt), a && L(Ce) && w) {
    if (!Xr && bt)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    O.current = t, R.current = n, x.current = !1;
    const j = k[w];
    if (!L(j)) {
      const P = Cr(j);
      hn(P);
    }
    if (L(Ft)) {
      const P = ot(yn);
      L(Rt) || (P.status = "fulfilled", P.value = !0), hn(P);
    } else
      throw Ft;
  }
  return {
    mutate: Cr,
    get data() {
      return $.data = !0, Rt;
    },
    get error() {
      return $.error = !0, Ft;
    },
    get isValidating() {
      return $.isValidating = !0, ya;
    },
    get isLoading() {
      return $.isLoading = !0, ba;
    }
  };
}, dc = sc(uc), mc = (e) => (t, n, r) => (r.revalidateOnFocus = !1, r.revalidateIfStale = !1, r.revalidateOnReconnect = !1, e(t, n, r)), fc = cc(dc, mc), _i = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "input"
  }], t = [{
    kind: "Variable",
    name: "input",
    variableName: "input"
  }], n = {
    kind: "InlineFragment",
    selections: [{
      alias: null,
      args: null,
      concreteType: "SimplenewsSubscriberUid",
      kind: "LinkedField",
      name: "uid",
      plural: !1,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriberUidEntity",
        kind: "LinkedField",
        name: "entity",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "uid",
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }, {
      alias: null,
      args: null,
      concreteType: "SimplenewsSubscriberSubscription",
      kind: "LinkedField",
      name: "subscriptions",
      plural: !0,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriberSubscriptionEntity",
        kind: "LinkedField",
        name: "entity",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "entityId",
          storageKey: null
        }, {
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "entityLabel",
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }],
    type: "SimplenewsSubscriber",
    abstractKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "errors",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "apisSignUpNewslettersApiMutation",
      selections: [{
        alias: null,
        args: t,
        concreteType: "EntityCrudOutput",
        kind: "LinkedField",
        name: "upsertNewsletterSubscriber",
        plural: !1,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: null,
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [
              n
              /*: any*/
            ],
            storageKey: null
          },
          r
          /*: any*/
        ],
        storageKey: null
      }],
      type: "Mutation",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "apisSignUpNewslettersApiMutation",
      selections: [{
        alias: null,
        args: t,
        concreteType: "EntityCrudOutput",
        kind: "LinkedField",
        name: "upsertNewsletterSubscriber",
        plural: !1,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: null,
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [
              {
                alias: null,
                args: null,
                kind: "ScalarField",
                name: "__typename",
                storageKey: null
              },
              n
              /*: any*/
            ],
            storageKey: null
          },
          r
          /*: any*/
        ],
        storageKey: null
      }]
    },
    params: {
      cacheID: "1fb3fb9786fa62f38926c967a5046b9b",
      id: null,
      metadata: {},
      name: "apisSignUpNewslettersApiMutation",
      operationKind: "mutation",
      text: `mutation apisSignUpNewslettersApiMutation(
  $input: NewsletterSubscriberInput
) {
  upsertNewsletterSubscriber(input: $input) {
    entity {
      __typename
      ... on SimplenewsSubscriber {
        uid {
          entity {
            uid
          }
        }
        subscriptions {
          entity {
            entityId
            entityLabel
          }
        }
      }
    }
    errors
  }
}
`
    }
  };
}();
_i.hash = "9c5f8eda66218d275fb91bd0162382c4";
const Mi = /* @__PURE__ */ function() {
  var e = [{
    alias: null,
    args: null,
    concreteType: "CurrentUserContext",
    kind: "LinkedField",
    name: "currentUserContext",
    plural: !1,
    selections: [{
      alias: null,
      args: null,
      concreteType: "ReverseUidSimplenewsSubscriber",
      kind: "LinkedField",
      name: "reverseUidSimplenewsSubscriber",
      plural: !1,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriber",
        kind: "LinkedField",
        name: "entities",
        plural: !0,
        selections: [{
          alias: null,
          args: null,
          concreteType: "SimplenewsSubscriberSubscription",
          kind: "LinkedField",
          name: "subscriptions",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            kind: "ScalarField",
            name: "status",
            storageKey: null
          }, {
            alias: null,
            args: null,
            concreteType: "SimplenewsSubscriberSubscriptionEntity",
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [{
              alias: null,
              args: null,
              kind: "ScalarField",
              name: "entityId",
              storageKey: null
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }],
    storageKey: null
  }];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "apisSignupNewsletterQuery",
      selections: e,
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "apisSignupNewsletterQuery",
      selections: e
      /*: any*/
    },
    params: {
      cacheID: "bee14d13a84d3a7ae570d06e18ab0d29",
      id: null,
      metadata: {},
      name: "apisSignupNewsletterQuery",
      operationKind: "query",
      text: `query apisSignupNewsletterQuery {
  currentUserContext {
    reverseUidSimplenewsSubscriber {
      entities {
        subscriptions {
          status
          entity {
            entityId
          }
        }
      }
    }
  }
}
`
    }
  };
}();
Mi.hash = "9ef62adb5a9764d0efceaca536e80013";
const pc = Mi, gc = (e) => async () => {
  var t, n;
  const r = await si(e, pc, {}).toPromise();
  return (t = r == null || (n = r.currentUserContext) === null || n === void 0 || (n = n.reverseUidSimplenewsSubscriber) === null || n === void 0 || (n = n.entities) === null || n === void 0 ? void 0 : n.flatMap((i) => {
    var a;
    return i == null || (a = i.subscriptions) === null || a === void 0 || (a = a.filter((s) => s == null ? void 0 : s.status)) === null || a === void 0 ? void 0 : a.map((s) => {
      var l;
      return s == null || (l = s.entity) === null || l === void 0 ? void 0 : l.entityId;
    });
  }).filter((i) => nt(i))) !== null && t !== void 0 ? t : [];
}, hc = _i, yc = (e, t, n, r = {}) => {
  const i = t.map((a) => ({
    source: JSON.stringify(r),
    status: "1",
    targetId: a
  }));
  return new Promise((a) => {
    Ia(e, {
      mutation: hc,
      onCompleted: (s) => {
        a(s.upsertNewsletterSubscriber);
      },
      variables: {
        input: {
          append: !0,
          mail: n,
          subscriptions: i
        }
      }
    });
  });
}, bc = "subscription_newsletterItems", Di = "subscription_dataMetrix", vc = Ti, Pi = () => {
  const {
    environment: e,
    handleSetV1SignedUpNewslettersLocalStorage: t,
    user: n,
    v1SignedUpNewsletters: r
  } = oe();
  e || console.error("Relay environment not found, make sure you wrapped your application with RelayEnvironmentProvider");
  const {
    set: i,
    value: a
  } = Nt(Aa, {
    defaultValue: 0
  }), {
    remove: s,
    value: l
  } = Nt(Di, {
    defaultValue: {}
  }), u = ue((k) => {
    n && i(Date.now()), t(k);
  }, [t, i, n]), f = () => Date.now() > Ba(a ?? 0, 60).getTime(), {
    data: g,
    mutate: d
  } = fc(n ? Ea : null, gc(e), {
    fallbackData: r,
    isPaused: () => !f(),
    onSuccess: (k) => u(k),
    refreshInterval: 1e3 * 30,
    revalidateOnMount: !0
  }), [m, v] = ye(!1);
  et(() => {
    g && v(!0);
  }, [g]);
  const S = ue(async (k, w) => {
    const T = await si(e, vc, {
      first: w,
      newsletterIds: k
    }).toPromise();
    return T == null ? void 0 : T.newsletters.edges.map(({
      node: E
    }) => {
      var x, A, O;
      return {
        alternativeName: E.alternativeName,
        description: (x = E.description) !== null && x !== void 0 && x.text ? {
          text: E.description.text
        } : void 0,
        entityId: E.entityId,
        homepageDescription: (A = E.homepageDescription) !== null && A !== void 0 && A.text ? {
          text: E.homepageDescription.text
        } : void 0,
        name: E.name,
        summary: (O = E.summary) !== null && O !== void 0 && O.text ? {
          text: E.summary.text
        } : void 0
      };
    });
  }, [e]), b = ue(async (k, w, T) => {
    const E = !nt(T), x = await yc(e, k, w, E ? l : T);
    if (nt(x.errors)) return x;
    const A = vn(g ?? [], k, r);
    return await d(A, {
      optimisticData: A,
      populateCache: !0,
      revalidate: !1,
      rollbackOnError: !0
    }), E && s(), u(A), x;
  }, [g, l, e, u, d, s, r]);
  return {
    data: g,
    fetchNewsletterByIds: S,
    handleSignUpNewsletter: b,
    isDataReady: m,
    mutate: d
  };
}, wc = () => {
  const {
    data: e
  } = Pi(), {
    v1SignedUpNewsletters: t
  } = oe(), [n, r] = ye(vn(e ?? [], t ?? []));
  return et(() => {
    const i = setTimeout(() => r(vn(e ?? [], t ?? [])), 1500);
    return () => clearTimeout(i);
  }, [e, t]), n;
}, xc = (e) => e == null ? void 0 : e.name, Re = (e) => {
  switch (e) {
    case U.AcquisitionNewsletterPopup:
      return "ppto";
    case U.Article:
      return "article inline";
    case U.Footer:
      return "footer inline";
    case U.Homepage:
      return "homepage inline";
    case U.LiveArticle:
      return "article_side";
    case U.NewsletterArticle:
      return "newsletter article";
    case U.NewsletterArticleBottom:
      return "newsletter article";
    case U.NewsletterList:
      return "newsletter index";
    case U.Section:
      return "section inline";
  }
  return "newsletter index";
}, Sc = /* @__PURE__ */ h("img", {
  target: "e1expqve0"
})({
  name: "1f3tddi",
  styles: "inline-size:21px;block-size:18px"
});
function In() {
  return In = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, In.apply(null, arguments);
}
const kc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAOKADAAQAAAABAAAAMAAAAAA9JyOSAAAC8klEQVRoBe2aOY/UQBSEBzaBhDvjEDcJvwAQGWzCnQMBQohLWuC3QMx9ZZtwCyEEJGQgEWzMAiE3AbuC+kZ+o2czPWaMPeMeXFJtv26321WuXu/O0WqlcVDdSXFa/BUZ0Yx2PPyBBRq5JcZmKqQXL3jq4Kqq0ORYx/HUmiPuFO/TSfBQ7QWRyGPCcok9Ie5wosep/da8oz6mYwXa74q2625i5I0b2MpA5Ngm/WYQb60ZN7CUgcixTPrN4MxcdcacIczGDu9hDIMhbA8dqNk4HtiWQVictAuTWVvU0uehsyIZq2OzSaJeiD/FzYnARWq9p1QHgzyJXrpJH1UfEesEUjsn/hDNzDPVaM81OF+TLrkTbYF7GlspDhsbJYDUTJe1aJ4n5hrUnDZ26ec70Rag/SQeFYcBUjsrfhe9Jv4hQavhrw1ywmLxsugXpH4grhIHBVJ7LmZ1oA2NHn0ZtBN3q8im+Vljx0T2fVUIpYYWNHVDIYMsxJ26Imbv4iONrRbLRig1NGRT89cubNAW2aMim+YXjR0Xy0iT1M6I2d+1Xqlpegf/bJCVlojdXmI91vgaJhTEBp3H4z67S7hWr9T85UoxaAvuVfFe9IK+qn9S7CfNUGqszY7pB6Ua5MKhNJ/o2Fom5KBXaqzdL0o3aAK6pflNB0+L3dLslRprFUVlBhHEHb8m+i1L/VRcLxpCqXFukdRsXdpKDdqF9qn4IHqjpDmRMPuEZC7nlIGBGEQoL56vi95kt5o5Zb7QHphB6W5jv35m08QoYxwrGwM3iAESuiFagtRlpqblOhiKQbv6ARWwSgzVYJXGbO2UQf4WjTQag7HH2yTYJFjzO9Bs0ZoHlCuvSTD3FtV8QpNgzQPKlfdfJDjrbsMoGPYeZulMOYPrXB1r6T1MYfC1czLh6lhL7+EV71eOi3y4abio4rz41gYiafmo/ZR42OnFWxu892/vl4xKi6cO+OLabXFUzOEl9WU8c3pIxaQ4LcZmFs1oT32d8jfZJ27pe+yPvgAAAABJRU5ErkJggg==", Cc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAOKADAAQAAAABAAAAMAAAAAA9JyOSAAADTElEQVRoBe2auW+TQRDF46SBhpCEikvcNJRUENGBm5yAaLgKFCEuKcDfQhoaIAl3DeEQQghooAIpRWoSKCFcBYnM71keNF7yxTb+bLOWR3ra2fl2Z97zSyxwnGlzkcvljrM9DHaDte5RDOkcJN+C+5lMZtwIZ5QgbBXLVXBE+yaIu2gYQei8CZygcLQJhHkJkwg8lsG9A1QfuSdPyMfArKvFkK6D5Fmw35HN6sfzDrB4QJJ31R2KJhV38NDEsN6WwGlX2BuNmgSiaOl1eqYlcMEVehLuRVNGyxqnZ6Ed5h2O/YLLY029hg4JXDJ4FfYt+eA/K8KzHfQm0nJ2Ku3UQdY9hbredNYnXm7wA7jtBK/BL7CrwH01+Z+QGB+dbPRO9MYVP5OfarCWovHwkWuXwU9g8ZJE3EsKXMmh63bLrVPkG4omNWADhx1AroUhzivA8gKNMwf7wBzw8YXNiJ2p58pcuXYJ/AA+Ztn0GRfy8gTqAoe7wA0QxmMKG61prVdmybVXIQn24tbl57MvX6Bd5FI/CN2cp3Ya1OxfPvROck1c+o2fX6lXLlANuCg3x0EYTyls8kPSyOmZ5Jo4FLnm5/Hs3wRaExoMgNDNr9TOgKrdpIdcuwjC37VE14ybVu5VJ7DQpJtGEyCMZxQ2+4GV5NzdDvR2H4ZmJbrmZ3CueoHWkGaD4CPw8Y3NOVC2m5xNck29B2xeOSvn0xOogTRMcvM5z7aUIsWZ5VzrLnU/fJ66QBtA46Xc/E79AvjLTWrLuTZofStd6Zuug54AzeXmJAjjBYVtdpY8yTXdrdg166uV+7UTaIMYMgQ+AR9yc7SA8B1SZ4fsfjUrfWovUAQZ1ANuglKhM6n9R5te9RFoLjBwGIRuUsrXhu1cWit96ytQxBkqN28BC+WpueZfHPrWX6ARYPhBwfa1WBsqsBaCwp6hwMTPZMKLse5bAmN1zni3HLRXIta15WCszhnvloP2SsS6thyM1Tnj3XLQXolYVzm46Mg3g6New6I2M07gVpfHmnoNMxL43ikZdXmsqdfwTn8RzaJkyqm5Rn4FfHC1GFL9qf08OOnIZvMfyCKyab/KZb+Q+grUPac89lRapKmt6CN1nDxB7RBomq9T/gb9K0lQ38SgeAAAAABJRU5ErkJggg==", Ui = ({
  ...e
}) => {
  var t;
  const n = _t();
  return /* @__PURE__ */ c.createElement(Sc, In({}, e, {
    src: (n == null || (t = n.newsletterIcon) === null || t === void 0 ? void 0 : t.icon) === "black" ? kc : Cc,
    "data-qa": "newsletter-icon"
  }));
};
Ui.displayName = "NewsletterIcon";
const dr = /* @__PURE__ */ h("div", {
  target: "e4lcx306"
})({
  name: "1xbksb9",
  styles: "display:flex;flex-flow:row;justify-content:space-between;align-items:center;margin-block:16px;margin-inline:0"
}), He = /* @__PURE__ */ h("div", {
  target: "e4lcx305"
})("color:#000000;font-size:18px;font-family:", me, ";line-height:23px;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.findOutMore) === null || t === void 0 ? void 0 : t.titleFontStyle) {
    case "large":
      return `
          font-size: 21px;
          line-height: 27px;
        `;
  }
}, ";"), mr = /* @__PURE__ */ h(Ui, {
  target: "e4lcx304"
})({
  name: "wb048k",
  styles: "inline-size:28px;block-size:24px"
}), Gt = /* @__PURE__ */ h("a", {
  target: "e4lcx303"
})(""), fr = /* @__PURE__ */ h("div", {
  target: "e4lcx302"
})(Gt, "{display:inline-block;inline-size:auto;color:#4585ff;font-size:14px;font-family:", D, ";line-height:16px;text-decoration:underline;cursor:pointer;}"), ji = /* @__PURE__ */ h("div", {
  target: "e4lcx301"
})({
  name: "ip6zvp",
  styles: "inline-size:60px;block-size:1px;margin-block-end:28px;background-color:#001246"
}), We = /* @__PURE__ */ h("div", {
  target: "e4lcx300"
})('display:grid;grid-template-areas:"SummaryLine" "Icon" "Message" "Button";justify-items:center;text-align:center;', mr, "{grid-area:Icon;}", fr, "{grid-area:Button;}", dr, "{grid-area:Message;}", ji, "{grid-area:SummaryLine;}");
function zn() {
  return zn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zn.apply(null, arguments);
}
const Vi = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    handleTrackGA4: n
  } = oe(), {
    campaignName: r,
    findOutMoreButtonDisplayComponent: i,
    variant: a
  } = ve(), s = _t();
  return /* @__PURE__ */ c.createElement(We, zn({}, e, {
    "data-qa": "find-out-more"
  }), (s == null ? void 0 : s.hasSummaryLine) && /* @__PURE__ */ c.createElement(ji, null), /* @__PURE__ */ c.createElement(mr, null), /* @__PURE__ */ c.createElement(dr, null, /* @__PURE__ */ c.createElement(He, null, "Sign up for our Newsletters")), /* @__PURE__ */ c.createElement(fr, null, /* @__PURE__ */ c.createElement(Gt, {
    href: "/newsletters",
    onClick: (l) => {
      l.preventDefault(), n({
        action: "click",
        category: "nl",
        customized_parameters: {
          internal_campaign: r ?? "",
          trigger_point: Re(a)
        },
        subcategory: "entry"
      }), t("/newsletters");
    }
  }, i ?? "Find out more")));
};
Vi.displayName = "FindOutMore";
const Ec = "Please enter a valid email address", Ac = "There was a problem. Please try again", bn = "";
function Tc(e) {
  return /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/.test(e);
}
const Oc = /* @__PURE__ */ h("span", {
  target: "ek9223x1"
})({
  name: "34b66o",
  styles: '::after{content:"";display:inline-block;animation:dotty steps(1, end) 2s infinite;}@keyframes dotty{0%{content:"";}25%{content:".";}50%{content:"..";}75%{content:"...";}100%{content:"";}}'
});
var Fc = {
  name: "c0yhd0",
  styles: "min-inline-size:82px"
}, Rc = {
  name: "1nw19os",
  styles: "min-inline-size:244px"
};
const Ue = /* @__PURE__ */ h("button", {
  target: "ek9223x0"
})("block-size:35px;min-inline-size:86px;color:#ffffff;font-size:14px;line-height:16px;border:0;border-radius:2px;background-color:#4585ff;cursor:pointer;", (e) => {
  switch (e.$buttonSize) {
    case "large":
      return Rc;
    case "small":
      return Fc;
  }
}, " ", pi, ";");
function Ln() {
  return Ln = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ln.apply(null, arguments);
}
const pr = ({
  children: e,
  isLoading: t,
  onClick: n,
  size: r = "medium",
  ...i
}) => {
  const a = (s) => {
    t || n(s);
  };
  return /* @__PURE__ */ c.createElement(Ue, Ln({}, i, {
    $buttonSize: r,
    onClick: a,
    "data-qa": "sign-up-button"
  }), t ? /* @__PURE__ */ c.createElement(Oc, null, "SENDING") : /* @__PURE__ */ c.createElement("span", null, e));
};
pr.displayName = "SignUpButton";
const Ic = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 17, viewBox: "0 0 17 17", ...e }, /* @__PURE__ */ y.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ y.createElement("path", { d: "M21-4H-3v24h24z" }), /* @__PURE__ */ y.createElement("path", { d: "M17 8.177H.875m8-8l-8 8 8 8", stroke: "#FEFEFE" }))), it = /* @__PURE__ */ h(Ic, {
  target: "e1kldszr7"
})({
  name: "gz16y9",
  styles: "path{stroke:#4585ff;}"
}), zc = /* @__PURE__ */ h("div", {
  target: "e1kldszr6"
})({
  name: "ebvuqd",
  styles: "display:flex;flex-flow:row;justify-content:stretch;align-items:center;margin-inline-end:12px;cursor:pointer"
}), qi = /* @__PURE__ */ h("input", {
  target: "e1kldszr5"
})("inline-size:100%;block-size:35px;padding-inline-start:10px;color:#000000;font-size:16px;font-family:", D, ";border:1px solid #d7d7d7;border-color:", (e) => e.$isError ? "#eb4254" : "#d7d7d7", ";border-radius:2px;&::placeholder{color:#999999;}"), Lc = /* @__PURE__ */ h("div", {
  target: "e1kldszr4"
})("margin-block:2px 0;margin-inline:2px 0;color:#eb4254;font-size:10px;font-family:", D, ";line-height:11px;"), Bc = /* @__PURE__ */ h("div", {
  target: "e1kldszr3"
})({
  name: "1ckj6g",
  styles: "margin-inline-end:8px"
}), Nc = /* @__PURE__ */ h("form", {
  target: "e1kldszr2"
})({
  name: "zjik7",
  styles: "display:flex"
}), $c = /* @__PURE__ */ h("div", {
  target: "e1kldszr1"
})({
  name: "zjik7",
  styles: "display:flex"
}), Qt = /* @__PURE__ */ h(pr, {
  target: "e1kldszr0"
})("");
function Bn() {
  return Bn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bn.apply(null, arguments);
}
const Hi = ({
  onPreviousClick: e,
  onSubmit: t,
  ...n
}) => {
  const [r, i] = ye(""), [a, s] = ye(bn), [l, u] = ye(!1), {
    executeRecaptcha: f
  } = Ua(), g = async () => {
    if (!Tc(r)) {
      s(Ec);
      return;
    }
    u(!0);
    const d = await (f == null ? void 0 : f());
    if (!d) return;
    s(bn);
    const m = await t({
      email: r,
      recaptchaToken: d
    });
    m != null && m.error && (s(Ac), u(!1));
  };
  return /* @__PURE__ */ c.createElement($c, Bn({}, n, {
    "data-qa": "email-form"
  }), /* @__PURE__ */ c.createElement(zc, null, /* @__PURE__ */ c.createElement(it, {
    height: "15",
    onClick: e,
    width: "15"
  })), /* @__PURE__ */ c.createElement(Nc, {
    method: "post",
    onSubmit: (d) => {
      d.preventDefault(), g();
    }
  }, /* @__PURE__ */ c.createElement(Bc, null, /* @__PURE__ */ c.createElement(qi, {
    $isError: !!a,
    onChange: (d) => {
      d.target.value || s(bn), i(d.target.value);
    },
    placeholder: "Email",
    value: r
  }), a && /* @__PURE__ */ c.createElement(Lc, null, a)), /* @__PURE__ */ c.createElement(Qt, {
    isLoading: l,
    onClick: (d) => {
      d.preventDefault(), g();
    }
  }, "SIGN UP")));
};
Hi.displayName = "EmailForm";
let Z = /* @__PURE__ */ function(e) {
  return e.EmailForm = "email-form", e.OverlaySignUpButton = "overlay-sign-up-button", e.SignUpButton = "sign-up-button", e.SocialButtons = "social-buttons", e;
}({}), Nn = /* @__PURE__ */ function(e) {
  return e.Email = "email", e.Facebook = "facebook", e.Google = "google", e;
}({});
const _c = () => {
  const {
    config: e
  } = oe();
  return {
    getSocialLoginUrl: (n, r, i) => {
      const a = new URL(e.accounts.host), s = new URL(location.href);
      s.search = Fr.stringify(r);
      const {
        triggerPoint: l,
        ...u
      } = r, f = new URL(location.href);
      return f.search = Fr.stringify(u), a.searchParams.set("callback", f.toString()), a.searchParams.set("destination", s.toString()), a.searchParams.set("nonce", ""), a.searchParams.set("optIn", i ? "true" : "false"), a.searchParams.set("triggerPoint", l), a.pathname = `/login/${n}`, a.toString();
    }
  };
}, Mc = (e) => /* @__PURE__ */ y.createElement("svg", { width: 22, height: 19, viewBox: "0 0 22 19", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M22 7.548v9.1c0 1.15-.99 2.09-2.2 2.09H2.2c-1.21 0-2.2-.94-2.2-2.09l.007-9.1 11.026 4.635L22 7.548zM19.8.738c1.21 0 2.2.94 2.2 2.089v3.332l-10.968 4.669L.008 6.16l.003-3.333c0-1.1.896-2.007 2.033-2.084L2.2.738z", fill: "#AAA" })), Dc = (e) => /* @__PURE__ */ y.createElement("svg", { width: 22, height: 23, viewBox: "0 0 22 23", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M22 11.805C22 5.692 17.075.738 11 .738S0 5.692 0 11.805c0 5.524 4.023 10.102 9.281 10.933v-7.734H6.488v-3.2h2.793V9.367c0-2.773 1.642-4.305 4.155-4.305 1.204 0 2.462.216 2.462.216V8h-1.387c-1.366 0-1.792.853-1.792 1.729v2.076h3.05l-.487 3.199h-2.563v7.734c5.258-.83 9.281-5.41 9.281-10.933", fill: "#1977F2", fillRule: "evenodd" })), Pc = (e) => /* @__PURE__ */ y.createElement("svg", { width: 22, height: 23, viewBox: "0 0 22 23", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ y.createElement("path", { d: "M21.168 11.783c0-.766-.069-1.502-.196-2.21H10.8v4.179h5.812a4.968 4.968 0 0 1-2.155 3.26v2.709h3.49c2.043-1.88 3.221-4.649 3.221-7.938z", fill: "#4285F4", fillRule: "nonzero" }), /* @__PURE__ */ y.createElement("path", { d: "M10.8 22.338c2.916 0 5.36-.968 7.148-2.617l-3.49-2.71c-.968.648-2.205 1.031-3.658 1.031-2.813 0-5.194-1.9-6.043-4.452H1.149v2.798a10.796 10.796 0 0 0 9.651 5.95z", fill: "#34A853", fillRule: "nonzero" }), /* @__PURE__ */ y.createElement("path", { d: "M4.757 13.59a6.492 6.492 0 0 1-.339-2.052c0-.712.123-1.404.339-2.052V6.687H1.149A10.796 10.796 0 0 0 0 11.537c0 1.743.417 3.393 1.149 4.85l3.608-2.797z", fill: "#FBBC05", fillRule: "nonzero" }), /* @__PURE__ */ y.createElement("path", { d: "M10.8 5.033c1.586 0 3.01.545 4.129 1.615l3.097-3.098C16.156 1.808 13.711.738 10.8.738c-4.222 0-7.874 2.42-9.651 5.95l3.608 2.798c.85-2.553 3.23-4.453 6.043-4.453z", fill: "#EA4335", fillRule: "nonzero" }), /* @__PURE__ */ y.createElement("path", { d: "M0 .738h21.6v21.6H0z" }))), de = /* @__PURE__ */ h("div", {
  target: "e1uwm9yr1"
})({
  name: "1qitn38",
  styles: "display:flex;flex-flow:row;justify-content:center;align-items:center;inline-size:52px;block-size:35px;margin-inline-end:12px;box-sizing:border-box;border:1px solid #d7d7d7;border-radius:2px;background:#000000;cursor:pointer"
}), gr = /* @__PURE__ */ h("div", {
  target: "e1uwm9yr0"
})({
  name: "1nb6kt7",
  styles: "display:flex;flex-flow:row;justify-content:flex-start;align-items:center"
});
function $n() {
  return $n = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $n.apply(null, arguments);
}
const Wi = ({
  isAgreedReceiveMarketing: e,
  onEmailClick: t,
  ...n
}) => {
  const {
    campaignName: r,
    dataMatrix: i,
    newsletterItems: a,
    queryParametersForSocialButtons: s,
    variant: l
  } = ve(), {
    getSocialLoginUrl: u
  } = _c(), {
    handleRoutePush: f,
    handleTrackGA4: g
  } = oe(), {
    set: d
  } = Nt(bc), {
    set: m
  } = Nt(Di), v = (b) => {
    var k, w;
    d(a), m(i), g({
      action: "click",
      category: "nl",
      customized_parameters: {
        method: b,
        newsletter_name: (k = a[0].name) !== null && k !== void 0 ? k : "",
        trigger_point: Re(l)
      },
      subcategory: "sign_up"
    });
    const T = a.filter((E) => E.entityId).map((E) => E.entityId);
    f(u(b, {
      campaignName: r,
      newsletterIds: T,
      newsletterName: (w = a[0].name) !== null && w !== void 0 ? w : "",
      subscription: "true",
      triggerPoint: Re(l),
      variant: l
    }, e), {
      query: s
    });
  }, S = $e(() => Na(), []);
  return /* @__PURE__ */ c.createElement(gr, $n({}, n, {
    "data-qa": "social-buttons"
  }), /* @__PURE__ */ c.createElement(de, {
    onClick: () => v(Nn.Facebook)
  }, /* @__PURE__ */ c.createElement(Dc, {
    height: "100%",
    width: "22"
  })), !S && /* @__PURE__ */ c.createElement(de, {
    onClick: () => v(Nn.Google)
  }, /* @__PURE__ */ c.createElement(Pc, {
    height: "100%",
    width: "22"
  })), /* @__PURE__ */ c.createElement(de, {
    onClick: t
  }, /* @__PURE__ */ c.createElement(Mc, {
    height: "100%",
    width: "22"
  })));
};
Wi.displayName = "SocialButtons";
const Ki = /* @__PURE__ */ h(pr, {
  target: "e1e053fq14"
})(""), hr = /* @__PURE__ */ h("div", {
  target: "e1e053fq13"
})({
  name: "e0dnmk",
  styles: "cursor:pointer"
}), Pe = /* @__PURE__ */ h("div", {
  target: "e1e053fq12"
})("max-inline-size:254px;margin-inline-end:8px;color:#666666;font-size:11px;font-family:", D, ";line-height:13px;"), vt = /* @__PURE__ */ h("div", {
  target: "e1e053fq11"
})("grid-area:Agreement;display:flex;margin-block-end:12px;", B.breakpoints.up("tablet"), "{margin-block-end:", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" ? "0" : "12px";
}, ";}:empty{margin-block-end:0;}"), Uc = /* @__PURE__ */ h("div", {
  target: "e1e053fq10"
})({
  name: "1501yv5",
  styles: "grid-area:Description;margin-block:4px 10px"
}), jc = /* @__PURE__ */ h("div", {
  target: "e1e053fq9"
})("font-size:14px;font-family:", me, ";line-height:19px;"), Zt = /* @__PURE__ */ h("div", {
  target: "e1e053fq8"
})({
  name: "110j674",
  styles: "grid-area:Summary;margin-block-end:4px"
});
var Vc = {
  name: "1b6c22i",
  styles: "font-size:11px;line-height:13px"
};
const Yt = /* @__PURE__ */ h("div", {
  target: "e1e053fq7"
})("color:#222222;font-size:12px;font-family:", D, ";line-height:14px;text-align:center;text-transform:uppercase;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.signUpNewsletter) === null || t === void 0 ? void 0 : t.summaryFontStyle) {
    case "small":
      return Vc;
  }
}, ";");
var qc = {
  name: "1vu3ru",
  styles: "font-size:15px;line-height:19px"
}, Hc = {
  name: "11tjyy3",
  styles: "font-size:21px;line-height:27px"
}, Wc = {
  name: "wh4tv7",
  styles: "font-weight:300;font-size:21px;font-style:italic;line-height:27px"
};
const be = /* @__PURE__ */ h("div", {
  target: "e1e053fq6"
})("color:#000000;font-size:18px;font-family:", me, ";line-height:23px;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.signUpNewsletter) === null || t === void 0 ? void 0 : t.titleFontStyle) {
    case "italic-large":
      return Wc;
    case "large":
      return Hc;
    case "small":
      return qc;
  }
}, ";"), wt = /* @__PURE__ */ h("div", {
  target: "e1e053fq5"
})({
  name: "1wl4b09",
  styles: "grid-area:Title;margin-block-end:8px"
}), rt = /* @__PURE__ */ h("div", {
  target: "e1e053fq4"
})({
  name: "cfcqlx",
  styles: "grid-area:Action;margin-block-end:10px"
}), xt = /* @__PURE__ */ h("a", {
  target: "e1e053fq3"
})({
  name: "4dv4e3",
  styles: "margin-block:0;margin-inline:2px"
}), Jt = /* @__PURE__ */ h("div", {
  target: "e1e053fq2"
})("grid-area:TermAndCondition;color:#999999;font-size:10px;font-family:", D, ";line-height:11px;", xt, "{color:#999999;text-decoration:underline;}"), Kc = /* @__PURE__ */ h("div", {
  target: "e1e053fq1"
})({
  name: "10rfpyb",
  styles: "grid-area:SummaryLine;inline-size:60px;block-size:1px;margin-block-end:16px;background-color:#001246"
});
var Gc = {
  name: "1y77c6w",
  styles: 'grid-template-areas:"SummaryLine" "Summary" "Title" "Description" "Agreement" "Action" "TermAndCondition";justify-items:center;text-align:center'
}, Qc = {
  name: "1wz5quw",
  styles: 'grid-template-areas:"SummaryLine Action" "Summary Action" "Title Action" "Description Action" "Agreement TermAndCondition";grid-template-rows:repeat(5, minmax(0, min-content));justify-items:center;text-align:center;column-gap:20px'
};
const fe = /* @__PURE__ */ h("div", {
  target: "e1e053fq0"
})('display:grid;grid-template-areas:"SummaryLine" "Summary" "Title" "Description" "Agreement" "Action" "TermAndCondition";grid-template-rows:repeat(7, minmax(0, min-content));justify-items:center;color:#ffffff;text-align:center;', B.breakpoints.up("tablet"), "{", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" ? Qc : Gc;
}, ";}"), Zc = () => {
  const {
    campaignName: e,
    dataMatrix: t,
    newsletterItems: n,
    variant: r
  } = ve(), {
    config: i,
    handleTrackGA4: a,
    handleTrackGTM: s,
    handleTrackMirror: l,
    user: u
  } = oe(), {
    handleSignUpNewsletter: f
  } = Pi(), {
    createUser: g
  } = Fa(i.accounts.host), [d] = oi("scmp_user_login_type"), m = nt(u == null ? void 0 : u.useremail), v = async (b) => {
    var k, w, T;
    if ((n == null ? void 0 : n.length) === 0) return {
      error: !0
    };
    const E = await f(n.map((x) => x.entityId), b, t);
    return (k = E.errors) !== null && k !== void 0 && k.length ? {
      error: !0
    } : (n.forEach((x, A) => {
      (() => {
        var R;
        if (r === U.AcquisitionNewsletterPopup) {
          var F;
          if (A > 0 || !e) return;
          a({
            action: "sys",
            category: "nl",
            customized_parameters: {
              internal_campaign: e ?? "",
              method: m ? (F = d == null ? void 0 : d.toLowerCase()) !== null && F !== void 0 ? F : "" : "email",
              newsletter_name: x.name,
              trigger_point: "ppto"
            },
            subcategory: "sign_up"
          });
          return;
        }
        a({
          action: "sys",
          category: "nl",
          customized_parameters: {
            internal_campaign: e ?? "",
            method: m ? (R = d == null ? void 0 : d.toLowerCase()) !== null && R !== void 0 ? R : "" : "email",
            newsletter_name: x.name,
            trigger_point: Re(r)
          },
          subcategory: "sign_up"
        });
      })(), l({
        event_name: "newsletter_sign_up",
        newsletter_subscribe: x.name
      }), s({
        event: "newsletter-subscribe",
        "newsletter-id": x.entityId,
        "newsletter-name": x.name
      });
    }), {
      error: !1,
      result: {
        uid: (w = (T = E.entity) === null || T === void 0 || (T = T.uid) === null || T === void 0 || (T = T.entity) === null || T === void 0 ? void 0 : T.uid) !== null && w !== void 0 ? w : ""
      }
    });
  };
  return {
    handleSubmit: v,
    handleSubmitWithEmail: async (b, k, w) => {
      try {
        var T;
        const E = await v(b);
        if (E.error) return E;
        (T = E.result) !== null && T !== void 0 && T.uid || (await g({
          newsletterId: JSON.stringify(n.map((x) => x.entityId)),
          newsletterName: JSON.stringify(n.map((x) => x.name)),
          optIn: w ? 1 : 0,
          recaptchaToken: k,
          recaptchaVersion: "v3",
          username: b
        }), a({
          action: "sys",
          category: "login",
          customized_parameters: {
            internal_campaign: e ?? "",
            method: "email",
            paywall_type: "newsletter_paywall",
            result: "register_success",
            trigger_point: "ppto"
          },
          subcategory: "result"
        }));
      } catch {
        return {
          error: !0
        };
      }
      return {
        error: !1
      };
    }
  };
}, Gi = ({
  isAgreedReceiveMarketing: e,
  isDisableSignupButtonMouseOver: t,
  isShowOverlaySignUp: n,
  onSuccess: r
}) => {
  const {
    handleTrackGA4: i,
    user: a
  } = oe(), {
    campaignName: s,
    newsletterItemForDisplay: l,
    newsletterItems: u,
    setLastSubscribedNewsletter: f,
    signUpButtonDisplayComponent: g,
    variant: d
  } = ve(), m = nt(a == null ? void 0 : a.useremail), [v] = oi("scmp_user_login_type"), [S, b] = ye(() => m ? Z.SignUpButton : n ? Z.OverlaySignUpButton : Z.SocialButtons), [k, w] = ye(!1), T = async () => {
    if ((() => {
      var F;
      if (d !== U.AcquisitionNewsletterPopup || !s) {
        var N, o;
        i({
          action: "click",
          category: "nl",
          customized_parameters: {
            method: m ? (N = v == null ? void 0 : v.toLowerCase()) !== null && N !== void 0 ? N : "" : "email",
            newsletter_name: (o = u[0].name) !== null && o !== void 0 ? o : "",
            trigger_point: Re(d)
          },
          subcategory: "sign_up"
        });
        return;
      }
      i({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          internal_campaign: s,
          message: (F = g == null ? void 0 : g.toString()) !== null && F !== void 0 ? F : "SIGN UP NOW",
          // eslint-disable-line @typescript-eslint/no-base-to-string
          step: "1"
        },
        subcategory: ""
      });
    })(), S === Z.OverlaySignUpButton)
      b(Z.SocialButtons);
    else if (m && a !== null && a !== void 0 && a.useremail) {
      w(!0);
      const {
        error: F
      } = await x(a.useremail);
      l && (f == null || f(l.name)), F || r();
    }
  }, E = () => {
    t || S !== Z.OverlaySignUpButton || b(Z.SocialButtons);
  }, {
    handleSubmit: x,
    handleSubmitWithEmail: A
  } = Zc();
  return {
    actionComponent: S,
    handleRenderActionComponent: () => {
      switch (S) {
        case Z.EmailForm:
          return /* @__PURE__ */ c.createElement(Hi, {
            onPreviousClick: () => b(Z.SocialButtons),
            onSubmit: async ({
              email: R,
              recaptchaToken: F
            }) => {
              var N;
              i({
                action: "click",
                category: "nl",
                customized_parameters: {
                  method: Nn.Email,
                  newsletter_name: (N = u[0].name) !== null && N !== void 0 ? N : "",
                  trigger_point: Re(d)
                },
                subcategory: "sign_up"
              });
              const o = await A(R, F, e);
              return o.error || r(), o;
            }
          });
        case Z.SocialButtons:
          return /* @__PURE__ */ c.createElement(Wi, {
            isAgreedReceiveMarketing: e,
            onEmailClick: () => {
              b(Z.EmailForm);
            }
          });
        default:
          return /* @__PURE__ */ c.createElement(Ki, {
            isLoading: k,
            onClick: () => void T(),
            onMouseOver: E,
            size: "large"
          }, g ?? "SIGN UP NOW");
      }
    }
  };
}, Yc = (e) => /* @__PURE__ */ y.createElement("svg", { width: "18px", height: "18px", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ y.createElement("title", null, "6D08B3E1-4507-43DB-B459-BF91FB343A6F"), /* @__PURE__ */ y.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ y.createElement("g", { id: "email_footer_3", transform: "translate(-297.000000, -361.000000)" }, /* @__PURE__ */ y.createElement("g", { id: "email_footer3", transform: "translate(32.000000, 301.000000)" }, /* @__PURE__ */ y.createElement("g", { id: "Tick", transform: "translate(0.000000, 56.000000)" }, /* @__PURE__ */ y.createElement("g", { id: "checkbox_checked", transform: "translate(265.000000, 4.000000)" }, /* @__PURE__ */ y.createElement("path", { d: "M16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 L16,0 L16,0 Z", id: "Shape", fill: "#484848" }), /* @__PURE__ */ y.createElement("polygon", { id: "Path", fill: "#000000", points: "17 1 17 17 1 17 1 1" }), /* @__PURE__ */ y.createElement("path", { d: "M6.69230769,12.1145318 L6.69584957,12.1111217 L6.69230769,12.1145318 Z M14.3322932,5 L15,5.62497311 L7.44005099,12.6985528 L7.10176706,13 L3,9.16213131 L3.66769707,8.53714907 L7.1099159,11.7579034 L14.3322932,5 Z", id: "icon_signedup_tick", fill: "#FFFFFF", fillRule: "nonzero" }))))))), Qi = (e) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ y.createElement("path", { d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z", fill: "#4585FF" }), /* @__PURE__ */ y.createElement("path", { fill: "#4585FF", d: "M17 1v16H1V1z" }), /* @__PURE__ */ y.createElement("path", { d: "M6.692 12.115l.004-.004-.004.004zM14.332 5l.668.625-7.56 7.074-.338.301L3 9.162l.668-.625 3.442 3.22L14.332 5z", fill: "#FFF", fillRule: "nonzero" }))), Zi = (e) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M17 1v16H1V1h16zm-1-1H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z", fill: "#CCC", fillRule: "evenodd" }));
function _n() {
  return _n = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _n.apply(null, arguments);
}
const Yi = ({
  isDisableSignupButtonMouseOver: e = !1,
  isShowOverlaySignUp: t = !1,
  onSuccess: n,
  ...r
}) => {
  var i, a, s, l;
  const {
    handleRoutePush: u,
    handleTrackGA4: f,
    user: g
  } = oe(), d = nt(g == null ? void 0 : g.useremail), m = _t(), [v, S] = di(!1), {
    campaignName: b,
    newsletterItemForDisplay: k,
    summaryComponent: w,
    titleComponent: T
  } = ve(), E = () => {
    if (v) {
      var R;
      return (m == null || (R = m.signUpNewsletter) === null || R === void 0 ? void 0 : R.checkboxStyle) === "black" ? /* @__PURE__ */ c.createElement(Yc, null) : /* @__PURE__ */ c.createElement(Qi, null);
    }
    return /* @__PURE__ */ c.createElement(Zi, {
      "data-qa": "render-checkbox"
    });
  }, {
    actionComponent: x,
    handleRenderActionComponent: A
  } = Gi({
    isAgreedReceiveMarketing: v,
    isDisableSignupButtonMouseOver: e,
    isShowOverlaySignUp: t,
    onSuccess: n
  }), O = xc(k);
  return /* @__PURE__ */ c.createElement(fe, _n({}, r, {
    "data-qa": "sign-up-newsletter"
  }), (m == null ? void 0 : m.hasSummaryLine) && /* @__PURE__ */ c.createElement(Kc, null), (m == null || (i = m.signUpNewsletter) === null || i === void 0 ? void 0 : i.hasSummary) && /* @__PURE__ */ c.createElement(Zt, null, /* @__PURE__ */ c.createElement(Yt, null, w ?? (k == null || (a = k.summary) === null || a === void 0 ? void 0 : a.text))), (m == null ? void 0 : m.hasTitle) && O && /* @__PURE__ */ c.createElement(wt, null, /* @__PURE__ */ c.createElement(be, null, T ?? O)), (m == null || (s = m.signUpNewsletter) === null || s === void 0 ? void 0 : s.hasDescription) && /* @__PURE__ */ c.createElement(Uc, null, /* @__PURE__ */ c.createElement(jc, null, k == null || (l = k.description) === null || l === void 0 ? void 0 : l.text)), !d && /* @__PURE__ */ c.createElement(vt, null, /* @__PURE__ */ c.createElement(Pe, null, "By submitting, you consent to receiving marketing emails from SCMP. If you don't want these, tick here"), /* @__PURE__ */ c.createElement(hr, {
    onClick: S
  }, E())), /* @__PURE__ */ c.createElement(mt, {
    mode: "out-in"
  }, /* @__PURE__ */ c.createElement(pt, {
    key: x,
    timeout: 500
  }, /* @__PURE__ */ c.createElement(rt, null, A()))), /* @__PURE__ */ c.createElement(Jt, null, "By registering, you agree to our", /* @__PURE__ */ c.createElement(xt, {
    href: "/terms-conditions",
    onClick: (R) => {
      R.preventDefault(), f({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/terms-conditions",
          internal_campaign: b ?? "",
          message: "T&C",
          step: "1"
        },
        subcategory: ""
      }), u("/terms-conditions");
    }
  }, "T&C"), "and", /* @__PURE__ */ c.createElement(xt, {
    href: "/privacy-policy",
    onClick: (R) => {
      R.preventDefault(), f({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/privacy-policy",
          internal_campaign: b ?? "",
          message: "Privacy Policy",
          step: "1"
        },
        subcategory: ""
      }), u("/privacy-policy");
    }
  }, "Privacy Policy")));
};
Yi.displayName = "SignUpNewsletter";
const Ji = /* @__PURE__ */ h("iframe", {
  target: "emit8cs2"
})({
  name: "nw1hot",
  styles: "margin-inline-start:12px;border:none;overflow:hidden"
}), Et = /* @__PURE__ */ h("div", {
  target: "emit8cs1"
})("color:#6f6f6f;font-size:12px;font-family:", D, ";line-height:16px;"), Xi = /* @__PURE__ */ h("div", {
  target: "emit8cs0"
})('display:grid;grid-template-areas:"Description LikeWidget";', Ji, "{grid-area:LikeWidget;}", Et, "{grid-area:Description;}");
function Mn() {
  return Mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mn.apply(null, arguments);
}
const yr = ({
  ...e
}) => {
  const {
    config: t,
    handleTrackGA4: n
  } = oe(), {
    campaignName: r,
    lastSubscribedNewsletter: i,
    variant: a
  } = ve(), {
    activeElement: s
  } = Ra(), l = ue((u) => {
    s === u && n({
      action: "click",
      category: "nl",
      customized_parameters: {
        internal_campaign: r ?? "",
        newsletter_name: i ?? "",
        trigger_point: Re(a)
      },
      subcategory: "like"
    });
  }, [s, n, r, a, i]);
  return /* @__PURE__ */ c.createElement(Xi, Mn({}, e, {
    "data-qa": "follow-us-on-facebook"
  }), /* @__PURE__ */ c.createElement(Et, null, " Follow us on Facebook to get our latest news."), /* @__PURE__ */ c.createElement(Ji, {
    allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
    allowFullScreen: !0,
    frameBorder: 0,
    height: "21",
    ref: l,
    scrolling: "no",
    src: t.facebook.likeUrl,
    width: "100"
  }));
};
yr.displayName = "FollowUsOnFacebook";
const Jc = (e) => /* @__PURE__ */ y.createElement("svg", { width: 25, height: 26, viewBox: "0 0 25 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M25 13C25 19.9036 19.4036 25.5 12.5 25.5C5.59644 25.5 0 19.9036 0 13C0 6.09644 5.59644 0.5 12.5 0.5C19.4036 0.5 25 6.09644 25 13Z", fill: "#FFCA05" }), /* @__PURE__ */ y.createElement("path", { d: "M10.0957 16.4492L10.0996 16.4454L10.0957 16.4492Z", fill: "#001246" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9194 19.1667L5 13.1442L7.38647 10.7473L10.9194 14.3106L17.6141 7.5L20 9.92801L10.9194 19.1667Z", fill: "#001246" })), br = /* @__PURE__ */ h(Jc, {
  target: "evzk65t7"
})("");
var Xc = {
  name: "itm9fh",
  styles: "font-size:16px;line-height:20px"
};
const je = /* @__PURE__ */ h("div", {
  target: "evzk65t6"
})("grid-area:Title;font-weight:700;font-size:20px;font-family:", me, ";line-height:25px;", (e) => {
  var t;
  if (((t = e.theme) === null || t === void 0 || (t = t.signUpSuccess) === null || t === void 0 ? void 0 : t.titleFontStyle) === "small")
    return Xc;
}, ";"), Xt = /* @__PURE__ */ h("div", {
  target: "evzk65t5"
})({
  name: "1mkq020",
  styles: "grid-area:Icon;inline-size:25px;block-size:25px;margin-block-end:8px"
}), at = /* @__PURE__ */ h(yr, {
  target: "evzk65t4"
})({
  name: "1u3slon",
  styles: "margin-block-start:24px;text-align:start"
});
var eu = {
  name: "1dgbe91",
  styles: "color:#ffffff"
}, tu = {
  name: "d10iyn",
  styles: "color:#a1a1a1"
};
const qe = /* @__PURE__ */ h("div", {
  target: "evzk65t3"
})("grid-area:CheckEmail;margin-block-end:8px;padding-block-start:12px;color:#000000;font-size:14px;font-family:", me, ";line-height:18px;", (e) => {
  var t, n;
  if (((t = e.theme) === null || t === void 0 || (t = t.signUpSuccess) === null || t === void 0 ? void 0 : t.checkEmailMessageStyle) === "gray")
    return tu;
  if (((n = e.theme) === null || n === void 0 || (n = n.signUpSuccess) === null || n === void 0 ? void 0 : n.checkEmailMessageStyle) === "white")
    return eu;
}, ";"), vr = /* @__PURE__ */ h("a", {
  target: "evzk65t2"
})("grid-area:SeeMoreLink;font-size:14px;font-family:", D, ";line-height:18px;text-decoration:underline;cursor:pointer;"), nu = /* @__PURE__ */ h("div", {
  target: "evzk65t1"
})('grid-area:Footer;display:grid;grid-template-areas:"CheckEmail" "SeeMoreLink" "FollowOnFacebook";', B.breakpoints.up("mediumDesktop"), "{border-color:#eeeeee;}", vr, "{color:#4585ff;}"), Ie = /* @__PURE__ */ h("div", {
  target: "evzk65t0"
})({
  name: "1hilg2l",
  styles: 'display:grid;grid-template-areas:"Icon" "Title" "Footer";grid-template-columns:1fr;grid-column-gap:12px;justify-items:center;color:#001246;text-align:center'
});
function Dn() {
  return Dn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dn.apply(null, arguments);
}
const ea = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    handleTrackGA4: n
  } = oe(), {
    signUpSuccess: r
  } = _t(), {
    campaignName: i,
    variant: a
  } = ve(), s = a === U.AcquisitionNewsletterPopup ? "Please check the email for further details." : "Please check your email to confirm your subscription.", l = a === U.AcquisitionNewsletterPopup ? "Thank you for your registration." : "Thanks for signing up to our newsletter!";
  return /* @__PURE__ */ c.createElement(Ie, Dn({}, e, {
    "data-qa": "sign-up-success-message"
  }), /* @__PURE__ */ c.createElement(Xt, null, /* @__PURE__ */ c.createElement(br, {
    height: 25,
    width: 25
  })), /* @__PURE__ */ c.createElement(je, null, l), /* @__PURE__ */ c.createElement(nu, null, (r == null ? void 0 : r.hasCheckEmail) && /* @__PURE__ */ c.createElement(qe, null, s), (r == null ? void 0 : r.hasSeeMoreLinks) && /* @__PURE__ */ c.createElement(vr, {
    onClick: (u) => {
      u.preventDefault(), n({
        action: "click",
        category: "nl",
        customized_parameters: {
          internal_campaign: i ?? "",
          trigger_point: Re(a)
        },
        subcategory: "entry"
      }), t("/newsletters");
    }
  }, "See more newsletters"), /* @__PURE__ */ c.createElement(at, null)));
};
ea.displayName = "SignUpSuccessMessage";
const ru = /* @__PURE__ */ h(Vi, {
  target: "e34cblv4"
})(""), At = /* @__PURE__ */ h(Yi, {
  target: "e34cblv3"
})(""), iu = /* @__PURE__ */ h(ea, {
  target: "e34cblv2"
})(""), au = {
  findOutMore: {
    titleFontStyle: "medium"
  },
  hasSummaryLine: !1,
  hasTitle: !0,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    hasDescription: !1,
    hasSummary: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "medium"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "small"
  }
};
var ou = {
  name: "1wwwzme",
  styles: "max-inline-size:720px"
}, su = {
  name: "1o60ovs",
  styles: "max-inline-size:300px"
}, lu = {
  name: "1k15hls",
  styles: "max-inline-size:307px"
}, cu = {
  name: "enj17d",
  styles: "max-inline-size:640px"
};
const ta = /* @__PURE__ */ h("div", {
  target: "e34cblv1"
})("block-size:auto;font-family:", D, ";", B.breakpoints.up("desktop"), "{", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.root) === null || t === void 0 ? void 0 : t.containerSize) {
    case "large":
      return cu;
    case "medium":
      return lu;
    case "small":
      return su;
  }
}, " ", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" && ou;
}, ";}", (e) => e.theme.root.customCss, ";"), uu = /* @__PURE__ */ h("div", {
  target: "e34cblv0"
})(""), du = (e) => ui(au, e), mu = /* @__PURE__ */ h("div", {
  target: "e1252bbu0"
})(""), ge = ({
  children: e,
  theme: t
}) => /* @__PURE__ */ c.createElement(mu, {
  "data-qa": "variant-base"
}, /* @__PURE__ */ c.createElement(ja, {
  theme: du(t)
}, e));
ge.displayName = "VariantBase";
const fu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  hasTitle: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, pu = /* @__PURE__ */ h("div", {
  target: "ejc3no00"
})(ta, "{max-inline-size:100%;}", fe, "{justify-items:center;text-align:start;", de, "{background-color:#ffffff;}", Pe, ",", xt, ",", Jt, "{color:#ffffff;line-height:12px;text-align:center;}", Ue, "{min-inline-size:240px;color:#001246;font-size:14px;font-family:", D, ";background-color:#ffca05;}", vt, "{align-items:center;", Pe, "{max-inline-size:278px;line-height:13px;text-align:start;opacity:0.7;}", hr, "{display:flex;svg{color:#ffffff;background-color:#ffffff;}}}", Qt, "{min-inline-size:86px;}}", Ie, "{justify-content:center;color:#ffca05;text-align:start;", je, "{font-size:21px;line-height:27px;text-align:center;}", qe, "{color:#ffca05;font-size:16px;text-align:center;}", at, "{align-items:center;}}"), gu = {
  defaultDisplayComponent: X.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
};
function Pn() {
  return Pn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pn.apply(null, arguments);
}
const hu = (e) => ({
  [X.SignUpNewsletter]: (t) => /* @__PURE__ */ c.createElement(At, Pn({
    isDisableSignupButtonMouseOver: !0,
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), na = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: fu,
  "data-qa": "acquisition-newsletter-popup-theme"
}, /* @__PURE__ */ c.createElement(pu, t, e));
na.displayName = "AcquisitionNewsletterPopupTheme";
const yu = (e) => /* @__PURE__ */ y.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), Gd = /* @__PURE__ */ h("div", {
  target: "euah2f21"
})("inline-size:100%;font-size:12px;font-family:", D, ";"), bu = /* @__PURE__ */ h(yu, {
  target: "euah2f20"
})({
  name: "1o82tng",
  styles: "margin-inline-end:12px"
}), vu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "custom",
    customCss: {
      name: "16bq70n",
      styles: "max-inline-size:260px"
    }
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasDescription: !1,
    summaryFontStyle: "medium",
    titleFontStyle: "large"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, wu = /* @__PURE__ */ h("div", {
  target: "e1vgfju90"
})(Ie, '{grid-template-areas:"Title Icon" "Footer Footer";grid-template-columns:1fr min-content;color:#000000;text-align:start;', je, "{font-weight:700;font-size:18px;font-family:", gt, ";line-height:normal;}", qe, "{margin-block-end:12px;font-size:12px;font-family:", D, ";line-height:normal;}", at, "{margin-block-start:0;", Et, "{color:#666666;font-size:10px;line-height:normal;}}", br, "{path:first-child{fill:#eb4254;}path:last-child{fill:#ffffff;}}}", We, "{text-align:center;", He, "{color:#000000;}", bu, "{display:none;}}", fe, "{justify-items:left;color:#000000;font-family:", gt, ";text-align:start;", it, "{path{stroke:#000000;}}", Pe, "{color:#999999;}", Jt, ",", xt, "{color:#666666;}", de, "{background-color:#ffffff;}", Ki, "{inline-size:100%;block-size:38px;}", Qt, "{min-inline-size:70px;font-size:12px;font-family:", D, ";line-height:14px;}", wt, ",", rt, ",", Zt, "{margin-block-end:12px;}", rt, "{inline-size:100%;}", vt, "{flex-direction:row-reverse;gap:8px;", Pe, "{margin-inline-end:0;color:#333333;font-weight:400;font-size:11px;font-family:", D, ";line-height:13px;}}}");
function Un() {
  return Un = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Un.apply(null, arguments);
}
const xu = (e) => ({
  [X.SignUpNewsletter]: (t) => /* @__PURE__ */ c.createElement(At, Un({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), ra = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: vu,
  "data-qa": "article-20-theme"
}, /* @__PURE__ */ c.createElement(wu, t, e));
ra.displayName = "Article20Theme";
const ia = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "custom",
    customCss: /* @__PURE__ */ re("max-inline-size:335px;", B.breakpoints.up("tablet"), "{max-inline-size:440px;}", "")
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasDescription: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "large"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, aa = /* @__PURE__ */ h("div", {
  target: "e14px9co0"
})(Ie, '{grid-template-areas:"Title Icon" "Footer Footer";grid-template-columns:1fr min-content;color:#001246;text-align:start;', B.breakpoints.up("tablet"), "{text-align:center;}", at, "{margin-block-start:12px;}", br, "{path:first-child{fill:#eb4254;}path:last-child{fill:#ffffff;}}}", We, "{text-align:center;", He, "{color:#000000;}}", fe, "{color:#000000;text-align:center;", it, "{path{stroke:#000000;}}", Pe, "{color:#999999;}", Zt, "{margin-block-end:8px;}", be, "{color:#001246;font-weight:700;font-size:20px;line-height:23px;}", de, "{background-color:#ffffff;}}"), Su = ui(ia, {
  newsletterIcon: {
    icon: "white"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "white"
  }
}), ku = /* @__PURE__ */ h(aa, {
  target: "e1h0z9h50"
})(Ie, "{color:#ffffff;", vr, ",", Et, "{color:#ffffff;}}", We, "{", He, ",", Gt, "{color:#ffffff;}}", fe, "{color:#ffffff;", it, "{path{stroke:#ffffff;}}", be, ",", Yt, "{color:#ffffff;}", be, " path{fill:#ffffff;}", Ue, "{background-color:#000000;}", be, "{color:#ffffff;}", de, "{background-color:#000000;}}"), oa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: Su,
  "data-qa": "article-dark-theme"
}, /* @__PURE__ */ c.createElement(ku, t, e));
oa.displayName = "ArticleDarkTheme";
function jn() {
  return jn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jn.apply(null, arguments);
}
const ni = (e) => ({
  [X.SignUpNewsletter]: (t) => /* @__PURE__ */ c.createElement(At, jn({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), sa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: ia,
  "data-qa": "article-theme"
}, /* @__PURE__ */ c.createElement(aa, t, e));
sa.displayName = "ArticleTheme";
const Cu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, Eu = /* @__PURE__ */ h("div", {
  target: "eok5vf10"
})(it, "{path{stroke:#ffffff;}}", He, "{color:#ffffff;}", Ue, "{background-color:#000000;}", fe, "{", Pe, "{color:#a1a1a1;}", be, ",", Yt, "{color:#ffffff;}}", Ie, '{grid-template-areas:"Icon Title" ". Footer";grid-template-columns:min-content 1fr;color:#ffffff;text-align:start;', at, "{margin-block-start:0;}", je, "{text-align:start;}}", B.breakpoints.up("tablet"), "{", We, ",", fe, "{justify-items:flex-start;text-align:start;}}"), la = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: Cu,
  "data-qa": "footer-theme"
}, /* @__PURE__ */ c.createElement(Eu, t, e));
la.displayName = "FooterTheme";
const Au = {
  findOutMore: {
    titleFontStyle: "large"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    summaryFontStyle: "medium",
    titleFontStyle: "medium"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, Tu = /* @__PURE__ */ h("div", {
  target: "e1jfys6k0"
})(de, "{background-color:#ffffff;}", fe, "{", be, "{color:#001246;}}"), ca = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: Au,
  "data-qa": "live-article-theme"
}, /* @__PURE__ */ c.createElement(Tu, t, e));
ca.displayName = "LiveArticleTheme";
const Ou = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "medium",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "small"
  }
}, Fu = /* @__PURE__ */ h("div", {
  target: "e1w0j1kx0"
})(be, "{color:#001246;}", wt, "{margin-block-end:12px;}", de, "{background-color:#ffffff;}", At, "{color:#001246;}", Ue, "{color:#ffffff;}", rt, "{margin-block-end:8px;}", Ie, '{grid-template-areas:"Icon Title" "Icon Footer";grid-template-columns:25px 1fr;justify-items:flex-start;max-inline-size:402.5px;margin-block:0;margin-inline:auto;text-align:start;', je, "{margin-block-end:4px;margin-block-end:4px;color:#001246;font-weight:400;font-family:", me, ";}", qe, "{margin-block-end:0;padding-block-start:0;color:#000000;font-size:12px;font-family:", D, ";line-height:14px;}", Xt, "{margin-block-end:0;}}"), Ru = {
  defaultDisplayComponent: X.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
}, ua = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: Ou,
  "data-qa": "newsletter-article-bottom-theme"
}, /* @__PURE__ */ c.createElement(Fu, t, e));
ua.displayName = "NewsletterArticleBottomTheme";
const Iu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, zu = /* @__PURE__ */ h("div", {
  target: "e1hazlo20"
})(fe, "{place-items:center center;text-align:start;", wt, "{margin-block-end:5px;}", be, "{max-inline-size:382px;color:#001246;font-size:18px;font-family:", me, ";line-height:23px;text-align:center;}", Zt, ",", vt, ",", wt, "{", B.breakpoints.up("tablet"), "{justify-self:flex-start;}}", Jt, "{", B.breakpoints.down("tablet"), "{text-align:center;}}", vt, "{align-items:center;}", hr, "{display:flex;}", rt, "{margin-block-end:0;}}", Ie, '{grid-template-areas:"Icon Title" "Icon Footer";grid-template-columns:25px 1fr;justify-items:flex-start;max-inline-size:402.5px;margin-block:0;margin-inline:auto;text-align:start;', je, "{margin-block-end:4px;color:#001246;font-weight:400;font-size:18px;font-family:", me, ";line-height:23px;", B.breakpoints.up("tablet"), "{margin-block-end:8px;}}", qe, "{margin-block-end:0;padding-block-start:0;color:#000000;font-size:14px;font-family:", D, ";line-height:18px;}", Xt, "{margin-block-end:0;}}", Ue, "{margin-block-end:8px;}", gr, "{justify-content:center;margin-block-end:8px;", B.breakpoints.up("tablet"), "{margin-block:10px 0;}", de, "{background-color:#ffffff;}}", Xi, "{margin-block-start:0;", Et, "{display:flex;align-items:center;}}"), Lu = {
  defaultDisplayComponent: X.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
}, da = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: Iu,
  "data-qa": "newsletter-article-theme"
}, /* @__PURE__ */ c.createElement(zu, t, e));
da.displayName = "NewsletterArticleTheme";
const Bu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, Nu = /* @__PURE__ */ h("div", {
  target: "e1njrwzb0"
})(fe, "{justify-items:flex-start;text-align:start;", be, "{max-inline-size:382px;color:#00001f;font-size:18px;font-family:", gt, ";line-height:21px;}}", qe, ",", je, "{color:#00001f;}", qe, "{margin-block-end:0;padding-block-start:8px;}", Xt, "{margin-block-end:0;}", de, "{background-color:#ffffff;}", rt, "{justify-self:center;}"), $u = {
  defaultDisplayComponent: X.SignUpNewsletter,
  hasResetAfterSuccess: !0,
  hasSanitizeSubscribedNewsletter: !1
}, ma = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: Bu,
  "data-qa": "newsletter-list-theme"
}, /* @__PURE__ */ c.createElement(Nu, t, e));
ma.displayName = "NewsletterListTheme";
const _u = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, Mu = /* @__PURE__ */ h("div", {
  target: "ez4a9ka0"
})(it, "{path{stroke:#000000;}}", He, "{color:#000000;}", Ue, "{background-color:#000000;}", fe, "{", Pe, "{color:#a1a1a1;}", be, ",", Yt, "{color:#000000;}}", Ie, '{grid-template-areas:"Icon Title" ". Footer";grid-template-columns:min-content 1fr;color:#000000;text-align:start;', at, "{margin-block-start:0;}", je, "{text-align:start;}}", B.breakpoints.up("tablet"), "{", We, ",", fe, "{justify-items:flex-start;text-align:start;}}"), fa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: _u,
  "data-qa": "posties-theme"
}, /* @__PURE__ */ c.createElement(Mu, t, e));
fa.displayName = "PostiesTheme";
const Du = (e) => /* @__PURE__ */ y.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), Pu = /* @__PURE__ */ h("div", {
  target: "e15wm59j1"
})("display:flex;align-items:center;color:#ffffff;font-size:14px;font-family:", D, ";text-transform:uppercase;"), Uu = /* @__PURE__ */ h(Du, {
  target: "e15wm59j0"
})({
  name: "t5e8y3",
  styles: "margin-inline-end:10px"
}), wr = ({
  children: e
}) => /* @__PURE__ */ c.createElement(Pu, {
  "data-qa": "homepage-theme-button-display"
}, /* @__PURE__ */ c.createElement(Uu, null), e);
wr.displayName = "HomepageThemeButtonDisplay";
const ju = /* @__PURE__ */ h("div", {
  target: "e1fn0hgx2"
})("color:#001246;font-weight:400;font-size:18px;font-family:", me, ";line-height:140%;"), Vu = /* @__PURE__ */ h("div", {
  target: "e1fn0hgx1"
})({
  name: "1b2kh57",
  styles: "font-size:14px;line-height:140%"
}), qu = /* @__PURE__ */ h("span", {
  target: "e1fn0hgx0"
})("font-weight:700;font-family:", me, ";"), xr = ({
  className: e
}) => {
  const {
    newsletterItemForDisplay: t
  } = ve(), n = $a(t == null ? void 0 : t.name, t == null ? void 0 : t.alternativeName);
  return /* @__PURE__ */ c.createElement(ju, {
    className: e,
    "data-qa": "title-display"
  }, /* @__PURE__ */ c.createElement(Vu, null, "Sign-up for"), /* @__PURE__ */ c.createElement(qu, null, n));
};
xr.displayName = "TitleDisplay";
const Hu = /* @__PURE__ */ h("div", {
  target: "eu7rj6m16"
})({
  name: "e0dnmk",
  styles: "cursor:pointer"
}), Wu = /* @__PURE__ */ h("div", {
  target: "eu7rj6m15"
})("max-inline-size:340px;margin-inline-start:8px;color:#000000;font-size:11px;font-family:", D, ";line-height:13px;text-align:start;"), Ku = /* @__PURE__ */ h("div", {
  target: "eu7rj6m14"
})("display:flex;margin-block-start:24px;", B.breakpoints.up("tablet"), "{margin-block-start:0;}"), Gu = /* @__PURE__ */ h("div", {
  target: "eu7rj6m13"
})({
  name: "1vkjxf6",
  styles: "margin-block-end:8px"
}), Vn = /* @__PURE__ */ h("a", {
  target: "eu7rj6m12"
})({
  name: "4dv4e3",
  styles: "margin-block:0;margin-inline:2px"
}), Qu = /* @__PURE__ */ h("div", {
  target: "eu7rj6m11"
})("color:#999999;font-size:10px;font-family:", D, ";line-height:11px;white-space:nowrap;", Vn, "{color:#999999;text-decoration:underline;}"), Zu = /* @__PURE__ */ h("div", {
  target: "eu7rj6m10"
})("display:flex;flex-flow:column;gap:2px;justify-items:center;max-inline-size:500px;margin:auto;padding:0;color:#ffffff;text-align:center;", Ue, "{display:flex;justify-content:center;align-items:center;block-size:36px;min-inline-size:173px;padding-inline:16px;", B.breakpoints.up("tablet"), "{min-inline-size:205px;}}", Qt, "{min-inline-size:86px;font-family:", D, ";}", gr, "{justify-content:center;", de, "{background-color:#ffffff;}}", qi, "{", B.breakpoints.up("tablet"), "{inline-size:186px;}}", B.breakpoints.up("tablet"), "{justify-items:center;max-inline-size:initial;margin:initial;text-align:center;}"), Yu = /* @__PURE__ */ h("div", {
  target: "eu7rj6m9"
})("display:flex;flex-flow:column;gap:16px;", B.breakpoints.up("tablet"), "{flex-flow:row;}"), pa = /* @__PURE__ */ h("div", {
  target: "eu7rj6m8"
})(B.breakpoints.up("tablet"), "{align-self:flex-end;}"), Ju = /* @__PURE__ */ h("div", {
  target: "eu7rj6m7"
})("inline-size:100%;text-align:center;", B.breakpoints.up("tablet"), "{text-align:start;}"), ri = /* @__PURE__ */ h("div", {
  target: "eu7rj6m6"
})(B.breakpoints.up("tablet"), "{margin-block-start:0;}"), Xu = /* @__PURE__ */ h("div", {
  target: "eu7rj6m5"
})("display:flex;flex-direction:column;align-items:center;inline-size:100%;", B.breakpoints.up("tablet"), "{justify-self:end;align-items:end;inline-size:unset;}"), ii = /* @__PURE__ */ h("div", {
  target: "eu7rj6m3"
})("display:flex;justify-content:center;", B.breakpoints.up("tablet"), "{gap:16px;justify-content:unset;}"), ed = /* @__PURE__ */ h("div", {
  target: "eu7rj6m2"
})("display:none;", B.breakpoints.up("tablet"), "{display:block;inline-size:100%;}"), td = /* @__PURE__ */ h("div", {
  target: "eu7rj6m1"
})("display:block;", B.breakpoints.up("tablet"), "{display:none;}"), nd = /* @__PURE__ */ h(xr, {
  target: "eu7rj6m0"
})({
  name: "c79c4p",
  styles: "margin-block-start:12px"
}), rd = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium",
    customCss: /* @__PURE__ */ re("max-inline-size:100%;", B.breakpoints.up("desktop"), "{max-inline-size:100%;}", "")
  }
}, id = /* @__PURE__ */ h("div", {
  target: "e1ds7hvh0"
})("padding-block:20px;padding-inline:24px;border:1px solid rgba(0, 0, 0, 0.2);border-radius:4px;background:#f6f6f6;", pa, "{margin-block-end:-8px;}", We, '{grid-template-areas:"Message" "Button";gap:16px;place-items:center center;', B.breakpoints.up("tablet"), '{grid-template-areas:"Message Button";justify-items:flex-start;}', Gt, "{padding-block:10px;padding-inline:16px;border-radius:2px;background-color:#4585ff;}", dr, "{margin-block:0;", B.breakpoints.up("tablet"), "{margin-inline-start:12px;}}", fr, "{", B.breakpoints.up("tablet"), "{justify-self:end;}}", He, "{color:#001246;", B.breakpoints.up("tablet"), "{font-size:18px;line-height:23px;}}", mr, "{display:none;}}"), qn = ({
  children: e,
  ...t
}) => /* @__PURE__ */ c.createElement(ge, {
  theme: rd,
  "data-qa": "homepage-theme"
}, /* @__PURE__ */ c.createElement(id, t, e)), Qd = () => /* @__PURE__ */ c.createElement(wr, {
  "data-qa": "homepage-theme-sign-up-button-display"
}, "Get Our Newsletter"), Zd = () => /* @__PURE__ */ c.createElement(wr, {
  "data-qa": "homepage-theme-find-our-more-display"
}, "Find Out More");
qn.displayName = "HomepageTheme";
const ad = /* @__PURE__ */ h("div", {
  target: "ebzef8g0"
})("color:#001246;font-weight:400;font-size:14px;font-family:", me, ";line-height:140%;"), Hn = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = ve();
  return /* @__PURE__ */ c.createElement(ad, {
    "data-qa": "description-display"
  }, t == null || (e = t.homepageDescription) === null || e === void 0 ? void 0 : e.text);
};
Hn.displayName = "DescriptionDisplay";
const od = (e) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("g", { id: "icon_email_24x24" }, /* @__PURE__ */ y.createElement("path", { id: "Fill 45", fillRule: "evenodd", clipRule: "evenodd", d: "M22 10.0606V18.1419C22 18.6539 21.8039 19.0912 21.4108 19.4547C21.0178 19.8182 20.5465 20 19.9961 20H4.00388C3.45423 20 2.98218 19.8182 2.58917 19.4547C2.19687 19.0912 2 18.6539 2 18.1419V10.0606L12.0194 14.1818L22 10.0606ZM22 8.80827L12.0194 12.9701L2 8.80827V5.85888C2 5.34688 2.19687 4.90876 2.58917 4.54525C2.98218 4.18175 3.45423 4 4.00388 4H19.9961C20.5465 4 21.0178 4.18175 21.4108 4.54525C21.8039 4.90876 22 5.34688 22 5.85888V8.80827Z", fill: "#4585FF" }))), sd = /* @__PURE__ */ h("div", {
  target: "essnwrk3"
})({
  name: "zpo6p0",
  styles: "display:flex;block-size:100%"
}), ld = /* @__PURE__ */ h("div", {
  target: "essnwrk2"
})("display:flex;flex-direction:row;gap:4px;justify-content:space-between;align-items:center;inline-size:100%;padding-block-end:8px;border-block-end:1px solid #001246;", B.breakpoints.up("tablet"), "{flex-direction:column;justify-content:unset;align-items:flex-start;padding-block-end:0;padding-inline-end:16px;border-block-end:0;border-inline-end:1px solid #001246;}"), cd = /* @__PURE__ */ h("span", {
  target: "essnwrk1"
})("display:flex;gap:8px;align-items:center;color:#4585ff;font-weight:700;font-size:14px;font-family:", gt, ";text-transform:uppercase;"), ud = /* @__PURE__ */ h("div", {
  target: "essnwrk0"
})("color:#001246;font-weight:700;font-size:14px;font-family:", gt, ";text-align:start;"), Wn = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = ve();
  return /* @__PURE__ */ c.createElement(sd, {
    "data-qa": "summary-display"
  }, /* @__PURE__ */ c.createElement(ld, null, /* @__PURE__ */ c.createElement(cd, null, /* @__PURE__ */ c.createElement(od, null), "NEWSLETTER"), /* @__PURE__ */ c.createElement(ud, null, t == null || (e = t.summary) === null || e === void 0 ? void 0 : e.text)));
};
Wn.displayName = "SummaryDisplay";
function Kn() {
  return Kn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kn.apply(null, arguments);
}
const ga = ({
  isDisableSignupButtonMouseOver: e = !1,
  isShowOverlaySignUp: t = !1,
  onSuccess: n,
  ...r
}) => {
  const {
    handleRoutePush: i,
    handleTrackGA4: a
  } = oe(), [s, l] = di(!1), {
    campaignName: u
  } = ve(), f = () => s ? /* @__PURE__ */ c.createElement(Qi, null) : /* @__PURE__ */ c.createElement(Zi, {
    "data-qa": "render-checkbox"
  }), {
    actionComponent: g,
    handleRenderActionComponent: d
  } = Gi({
    isAgreedReceiveMarketing: s,
    isDisableSignupButtonMouseOver: e,
    isShowOverlaySignUp: t,
    onSuccess: n
  }), m = () => /* @__PURE__ */ c.createElement(Ku, {
    "data-qa": "handle-render-agreement"
  }, /* @__PURE__ */ c.createElement(Hu, {
    onClick: l
  }, f()), /* @__PURE__ */ c.createElement(Wu, null, "By submitting, you consent to receiving marketing emails from SCMP. If you don't want these, tick here")), v = () => {
    const b = () => g === Z.OverlaySignUpButton || g === Z.SignUpButton ? /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(ri, null, /* @__PURE__ */ c.createElement(Wn, null)), /* @__PURE__ */ c.createElement(Ju, null, /* @__PURE__ */ c.createElement(xr, null), /* @__PURE__ */ c.createElement(Hn, null))) : m();
    return /* @__PURE__ */ c.createElement(ed, {
      "data-qa": "handle-render-tablet-up-content"
    }, /* @__PURE__ */ c.createElement(mt, {
      mode: "out-in"
    }, /* @__PURE__ */ c.createElement(pt, {
      key: String(g === Z.OverlaySignUpButton || g === Z.SignUpButton),
      timeout: 500
    }, /* @__PURE__ */ c.createElement(ii, null, b()))));
  }, S = () => {
    const b = () => g === Z.OverlaySignUpButton || g === Z.SignUpButton ? /* @__PURE__ */ c.createElement(Hn, null) : m();
    return /* @__PURE__ */ c.createElement(td, {
      "data-qa": "handle-render-mobile-content"
    }, /* @__PURE__ */ c.createElement(ri, null, /* @__PURE__ */ c.createElement(Wn, null)), /* @__PURE__ */ c.createElement(nd, null), /* @__PURE__ */ c.createElement(mt, {
      mode: "out-in"
    }, /* @__PURE__ */ c.createElement(pt, {
      key: String(g === Z.OverlaySignUpButton || g === Z.SignUpButton),
      timeout: 500
    }, /* @__PURE__ */ c.createElement(ii, null, b()))));
  };
  return /* @__PURE__ */ c.createElement(Zu, Kn({}, r, {
    "data-qa": "sign-up-newsletter"
  }), /* @__PURE__ */ c.createElement(Yu, null, v(), S(), /* @__PURE__ */ c.createElement(Xu, null, /* @__PURE__ */ c.createElement(mt, {
    mode: "out-in"
  }, /* @__PURE__ */ c.createElement(pt, {
    key: g,
    timeout: 500
  }, /* @__PURE__ */ c.createElement(Gu, null, d()))))), /* @__PURE__ */ c.createElement(pa, null, /* @__PURE__ */ c.createElement(Qu, null, "By registering, you agree to our", /* @__PURE__ */ c.createElement(Vn, {
    href: "/terms-conditions",
    onClick: (b) => {
      b.preventDefault(), a({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/terms-conditions",
          internal_campaign: u ?? "",
          message: "T&C",
          step: "1"
        },
        subcategory: ""
      }), i("/terms-conditions");
    }
  }, "T&C"), "and", /* @__PURE__ */ c.createElement(Vn, {
    href: "/privacy-policy",
    onClick: (b) => {
      b.preventDefault(), a({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/privacy-policy",
          internal_campaign: u ?? "",
          message: "Privacy Policy",
          step: "1"
        },
        subcategory: ""
      }), i("/privacy-policy");
    }
  }, "Privacy Policy"))));
};
ga.displayName = "SignUpNewsletter";
const dd = (e) => /* @__PURE__ */ y.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM18.2767 8L19 8.70309L10.8101 16.6609L10.4436 17L6 12.6824L6.72334 11.9793L10.4524 15.6026L18.2767 8Z", fill: "#EB4254" })), md = /* @__PURE__ */ h(dd, {
  target: "e18vlar15"
})(""), fd = /* @__PURE__ */ h("div", {
  target: "e18vlar14"
})("grid-area:Title;font-weight:400;font-size:18px;font-family:", me, ";line-height:23px;text-align:center;", B.breakpoints.up("tablet"), "{font-weight:700;line-height:25px;text-align:start;}"), pd = /* @__PURE__ */ h("div", {
  target: "e18vlar13"
})({
  name: "1mkq020",
  styles: "grid-area:Icon;inline-size:25px;block-size:25px;margin-block-end:8px"
}), gd = /* @__PURE__ */ h(yr, {
  target: "e18vlar12"
})('grid-area:FollowUsOnFacebook;grid-template-areas:"Description" "LikeWidget";grid-row-gap:4px;justify-items:center;text-align:center;', B.breakpoints.up("tablet"), "{justify-items:end;justify-self:end;text-align:start;}"), hd = /* @__PURE__ */ h("div", {
  target: "e18vlar11"
})("grid-area:CheckEmail;color:#001246;font-size:12px;font-family:", D, ";line-height:18px;text-align:center;"), yd = /* @__PURE__ */ h("div", {
  target: "e18vlar10"
})('display:grid;grid-template:"Icon" min-content "." 20px "Title" min-content "CheckEmail" min-content "." 48px "FollowUsOnFacebook" min-content/fit-content(100%);place-items:center;justify-content:center;color:#001246;', B.breakpoints.up("tablet"), '{grid-template:"Icon Title FollowUsOnFacebook" min-content "Icon CheckEmail FollowUsOnFacebook" min-content/max-content fit-content(50%) 1fr max-content;grid-gap:4px 12px;place-items:center start;}');
function Gn() {
  return Gn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gn.apply(null, arguments);
}
const ha = ({
  ...e
}) => /* @__PURE__ */ c.createElement(yd, Gn({}, e, {
  "data-qa": "sign-up-success-message"
}), /* @__PURE__ */ c.createElement(pd, null, /* @__PURE__ */ c.createElement(md, {
  height: 25,
  width: 25
})), /* @__PURE__ */ c.createElement(fd, null, "Thanks for signing up to our newsletter!"), /* @__PURE__ */ c.createElement(hd, null, "Please check your email to confirm your subscription."), /* @__PURE__ */ c.createElement(gd, null));
ha.displayName = "SignUpSuccessMessage";
function Qn() {
  return Qn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qn.apply(null, arguments);
}
const ai = (e) => ({
  [X.SignUpNewsletter]: (t) => /* @__PURE__ */ c.createElement(ga, Qn({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t)),
  [X.SignUpSuccessMessage]: (t) => /* @__PURE__ */ c.createElement(ha, null)
});
function Zn() {
  return Zn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zn.apply(null, arguments);
}
const bd = {
  defaultDisplayComponent: X.FindOutMore,
  hasResetAfterSuccess: !0,
  hasSanitizeSubscribedNewsletter: !0
}, vd = ({
  campaignName: e,
  children: t,
  hideWhenNoNewsletters: n = !1,
  isToggleSuccessMessage: r = !1,
  multipleNewsletters: i = !1,
  newsletterItems: a,
  onSuccess: s,
  trigger_point: l,
  variant: u,
  ...f
}) => {
  var g;
  const d = $e(() => ({
    [U.AcquisitionNewsletterPopup]: {
      config: gu,
      hook: hu,
      renderComponent: na
    },
    [U.Article]: {
      hook: ni,
      renderComponent: sa
    },
    [U.Article20]: {
      hook: xu,
      renderComponent: ra
    },
    [U.ArticleDark]: {
      hook: ni,
      renderComponent: oa
    },
    [U.Footer]: {
      renderComponent: la
    },
    [U.Homepage]: {
      hook: ai,
      renderComponent: qn
    },
    [U.LiveArticle]: {
      renderComponent: ca
    },
    [U.NewsletterArticle]: {
      config: Lu,
      renderComponent: da
    },
    [U.NewsletterArticleBottom]: {
      config: Ru,
      renderComponent: ua
    },
    [U.NewsletterList]: {
      config: $u,
      renderComponent: ma
    },
    [U.Posties]: {
      renderComponent: fa
    },
    [U.Section]: {
      hook: ai,
      renderComponent: qn
    }
  }), []), m = $e(() => d[u].renderComponent, [d, u]), v = $e(() => {
    var W;
    return (W = d[u].config) !== null && W !== void 0 ? W : bd;
  }, [d, u]), [S, b] = ye(!1), k = ue(() => {
    C(X.SignUpSuccessMessage), v.hasResetAfterSuccess && b(!0), s == null || s();
  }, [s, v]), w = {
    [X.FindOutMore]: (W) => /* @__PURE__ */ c.createElement(ru, W),
    [X.SignUpNewsletter]: (W) => /* @__PURE__ */ c.createElement(At, Zn({
      onSuccess: k
    }, W)),
    [X.SignUpSuccessMessage]: (W) => /* @__PURE__ */ c.createElement(iu, W)
  };
  et(() => {
    if (!S) return;
    const W = setTimeout(() => b(!1), Ta);
    return () => clearTimeout(W);
  }, [S, v.hasResetAfterSuccess]);
  const T = d[u].hook, E = (g = T == null ? void 0 : T(k)) !== null && g !== void 0 ? g : {}, x = Object.entries({
    ...w,
    ...E
  }).reduce((W, [we, Ce]) => (W[we] = Ce(), W), {}), A = wc(), O = Ka(() => v.hasSanitizeSubscribedNewsletter ? a.filter((W) => !A.includes(W.entityId)) : a, [a, A, v.hasSanitizeSubscribedNewsletter]), R = $e(() => Ai(O), [O]), F = ue(() => ({
    action: "imp",
    category: "nl",
    customized_parameters: {
      internal_campaign: e,
      newsletter_name: R == null ? void 0 : R.name,
      trigger_point: l ?? Re(u)
    },
    subcategory: "sign_up"
  }), [R, l, u, e]), {
    captureTrackImpressionEventTargetElement: N
  } = zl({
    ga4Event: F
  }), [o, C] = ye(v.defaultDisplayComponent), I = ue(() => {
    C(O.length > 0 ? X.SignUpNewsletter : v.defaultDisplayComponent);
  }, [O, v.defaultDisplayComponent]), z = Ca(I);
  et(() => {
    S || z.current();
  }, [S, z]), et(() => {
    r ? C(X.SignUpSuccessMessage) : z.current();
  }, [r, z]);
  const {
    dataMatrix: $,
    findOutMoreButtonDisplayComponent: Q,
    queryParametersForSocialButtons: se,
    signUpButtonDisplayComponent: Tt,
    summaryComponent: ze,
    titleComponent: Ot
  } = f;
  return n && O.length === 0 ? null : /* @__PURE__ */ c.createElement(Ll, {
    multipleNewsletters: i,
    value: {
      campaignName: e,
      dataMatrix: $,
      findOutMoreButtonDisplayComponent: Q,
      newsletterItems: O,
      queryParametersForSocialButtons: se,
      signUpButtonDisplayComponent: Tt,
      summaryComponent: ze,
      titleComponent: Ot,
      variant: u
    },
    "data-qa": "newsletter-widget"
  }, t, /* @__PURE__ */ c.createElement(m, f, /* @__PURE__ */ c.createElement(ta, {
    ref: N
  }, /* @__PURE__ */ c.createElement(mt, {
    mode: "out-in"
  }, /* @__PURE__ */ c.createElement(pt, {
    appear: !1,
    key: o,
    timeout: 500
  }, /* @__PURE__ */ c.createElement(uu, null, Object.entries(x).map(([W, we]) => /* @__PURE__ */ c.createElement(c.Fragment, {
    key: W
  }, W === o && we))))))));
};
vd.displayName = "NewsletterWidget";
export {
  Et as $,
  Ha as A,
  jd as B,
  Xa as C,
  vi as D,
  Wt as E,
  yr as F,
  Ne as G,
  Zd as H,
  Ms as I,
  kl as J,
  Gd as K,
  bu as L,
  Wd as M,
  vd as N,
  ve as O,
  xc as P,
  ks as Q,
  gi as R,
  Ge as S,
  Cl as T,
  Oo as U,
  U as V,
  di as W,
  ea as X,
  at as Y,
  je as Z,
  qe as _,
  Ll as a,
  Kd as a0,
  zl as a1,
  Qd as b,
  Tc as c,
  Dd as d,
  Pd as e,
  ne as f,
  Re as g,
  st as h,
  Le as i,
  Ud as j,
  wc as k,
  Zc as l,
  Gi as m,
  h as n,
  pt as o,
  Hd as p,
  vo as q,
  wo as r,
  pi as s,
  bo as t,
  Pi as u,
  ho as v,
  qd as w,
  Vd as x,
  yo as y,
  Ai as z
};
//# sourceMappingURL=index-FASoiSm9.mjs.map
